export default {
  "accessFromMobile.title": {
    en: "Sorry!",
    es: "¡Lo sentimos!",
  },
  "accessFromMobile.body": {
    en: "<strong> Quoters doesn't work on mobile phones. </strong> It's designed for your computer or tablet, where you can enjoy the full experience of quoting. We're sorry for the inconveniences and ... Happy quoting!",
    es: `<strong>Quoters no funciona móviles.</strong> Está pensado para que en tu ordenador o tableta disfrutes de una experiencia completa para mejorar tus presupuestos. Disculpas y... ¡Presupuesta feliz!`,
  },
  "accessFromMobile.footer": {
    en: "You can still keep on learning in our help centre.",
    es: "Puedes seguir aprendiendo en nuestro centro de ayuda.",
  },
  "accessFromMobile.helpButton": {
    en: "Go to help",
    es: "Ir a la ayuda",
  },
  "logInPage.form.email.placeholder": {
    en: "your.name@domain.com",
    es: "tu@email.com",
  },
  "logInPage.form.password.placeholder": {
    en: "Your password",
    es: "Tu contraseña",
  },
  "logInPage.rememberMe": {
    en: "Remember me for 7 days",
    es: "Recordarme 7 días",
  },
  "logInPage.skipTwoFactor": {
    en: "Skip two factor",
    es: "Saltar two factor",
  },
  "logInPage.verificationCode": {
    en: "We sent you a verification code to your email. Please, enter the code below:",
    es: "Se ha enviado el código de acceso a tu e-mail. Por favor, introdúcelo:",
  },
  "logInPage.form.verificationCode.placeholder": {
    en: "Your verification code",
    es: "Tu código de acceso",
  },
  "logInPage.forgotPassword": {
    en: "I forgot my password",
    es: "He olvidado mi contraseña",
  },
  "logInPage.login": {
    en: "Login",
    es: "Entra",
  },
  "logInPage.noAccount": {
    en: "No account yet? Sign up here",
    es: "¿No tienes cuenta? Créala aquí",
  },
  "logInPage.login.loading": {
    en: "Logging in...",
    es: "Autenticando...",
  },
  "logInPage.resetPassword.title": {
    en: "Reset password",
    es: "Restablecer contraseña",
  },
  "logInPage.resetPassword.text": {
    en: `Please, provide us your email.
         <br />
         <strong>We'll send you an email to reset your password.</strong>`,
    es: `Por favor, introduce tu dirección de correo electrónico.
         <br />
         <strong>Te enviaremos un email para restablecer tu contraseña.</strong>`,
  },
  "loginPage.resetPassword.form.email.placeholder": {
    en: "Your email",
    es: "Tu email",
  },
  "logInPage.formResetPassword.submit": {
    en: "Reset",
    es: "Enviar",
  },
  "logInPage.formResetPassword.submit.loading": {
    en: "Resetting...",
    es: "Enviando...",
  },
  "logInPage.formResetPassword.back": {
    en: "Go back",
    es: "Volver",
  },
  "signUpPage.form.name.placeholder": {
    en: "Your name",
    es: "Tu nombre",
  },
  "signUpPage.form.lastName.placeholder": {
    en: "Your last name",
    es: "Tus apellidos",
  },
  "signUpPage.form.email.placeholder": {
    en: "your.name@domain.com",
    es: "tu@email.com",
  },
  "signUpPage.form.password.placeholder": {
    en: "Your password",
    es: "Tu contraseña",
  },
  "signUpPage.form.password.patternError": {
    en: "8 to 20 Characters, one number and one letter.",
    es: "8 a 20 Caracteres, un número y una letra.",
  },
  "signUpPage.form.termsAndConditions": {
    en: 'I agree the <a href="https://quoters.io/terms-and-conditions-of-use/" target="_blank">Terms of use</a> and the <a href="https://www.quoters.io/legal-notice/" target="_blank">Privacy policy</a>',
    es: `Acepto los <a href="https://quoters.io/es/terminos-condiciones-uso/" target="_blank">Términos de uso</a> y
         la <a href="https://quoters.io/es/politica-de-privacidad/" target="_blank">Política de privacidad</a>`,
  },
  "signUpPage.form.termsAndConditions.requiredError": {
    en: "You have to agree the Terms of use and the Privacy policy to use Quoters",
    es: "Debes aceptar los Términos y Condiciones y la Política de privacidad para usar Quoters",
  },
  "signUpPage.form.newsletter": {
    en: "I want to get Quoters <i>newsletter</i> in my inbox.",
    es: `Quiero recibir vuestra <i>newsletter</i>.`,
  },
  "signUpPage.form.discounts": {
    en: "I want to get offers and discounts in my inbox.",
    es: `Quiero recibir descuentos y ofertas.`,
  },
  "signUpPage.form.submit": {
    en: "Sign in",
    es: `Regístrate`,
  },
  "signUpPage.form.submit.loading": {
    en: "Signing in...",
    es: `Registrando...`,
  },
  "signUpPage.goLogin": {
    en: "Have an account? Login to Quoters.",
    es: `¿Ya tienes una cuenta? Entra en Quoters.`,
  },
  "signUpPage.anyQuestion.title": {
    en: "Try Quoters 15 days for free!",
    es: `¡Prueba Quoters gratis durante 15 días!`,
  },
  "signUpPage.anyQuestion.text": {
    en: "All of Quoters features for you <strong>without any limit. No credit card needed!</strong>.<br /> Join now, improve your business sales <br /> and discover how Quoters can change everything for you.",
    es: `Todo Quoters para ti <strong>sin límites ni tarjeta de crédito</strong>.
         <br />
         Únete ya, comienza a simplificar los procesos de venta de tu empresa
         <br />
         y descubre cómo un presupuesto puede cambiarlo todo.`,
  },
  "resetPassword.summary": {
    en: "Update your password with this form:",
    es: "Actualiza tu contraseña con el siguiente formulario:",
  },
  "resetPassword.noValidToken": {
    en: "Your reset password token has expired or is invalid. Please ask for a new password reset and try again.",
    es: "Su solicitud de cambio de contraseña ha caducado o es incorrecta. Por favor vuelva a solicitar el cambio de contraseña y vuelva a intentarlo.",
  },
  "resetPassword.goToQuoters": {
    en: "Go to Quoters",
    es: "Ir a Quoters",
  },
  "resetPassword.changePassword": {
    en: "Change password",
    es: "Cambiar contraseña",
  },
  "resetPassword.changePassword.loading": {
    en: "Updating password...",
    es: "Cambiando contraseña...",
  },
  "resetPassword.newPassword.placeholder": {
    en: "New password",
    es: "Nueva contraseña",
  },
  "resetPassword.repeatPassword.placeholder": {
    en: "Confirm password",
    es: "Repite la contraseña",
  },

  "choosePlanModal.header.main": {
    en: "Your trial period has expired!",
    es: "¡Tu período de prueba ha finalizado!",
  },
  "choosePlanModal.header.trialMode": {
    en: "Start your <strong>15 days free trial</strong> by choosing the best plan for your and... Let's work!",
    es: "Para comenzar tu <strong>prueba gratis de 15 días</strong>, elige el plan que más te guste y... ¡a trabajar!",
  },
  "choosePlanModal.header.notTrialMode": {
    en: "Do you want to keep on quoting for __$1__ ?<br>Subscribe to one of our plans!",
    es: "¿Quieres seguir presupuestando con Quoters en la organización __$1__?<br>¡Suscríbete a uno de nuestros planes!",
  },
  "choosePlanModal.body.changeOrganizationButton": {
    en: "Switch between businesses",
    es: "Ir a otra organización",
  },
  "choosePlanModal.body.signout": {
    en: "Logout",
    es: "Cerrar sesión",
  },

  "organizations.selectDefault": {
    en: "Select your default organization (can be changed in any moment):",
    es: "Elige tu organización por defecto (puedes cambiarla en cualquier momento)",
  },
  "organizations.noAccount": {
    en: "Quoter's sign up can't be completed: there is no SmartVault's Organization where you're admin with Quoters enabled.",
    es: "No se ha podido completar el proceso de registro de Quoters. Se necesita al menos una Organización de la que seas administrador en SmartVault con Quoters activado.",
  },
  "organization.needsIntegration": {
    en: "To use this organization, a SmartVault admin has to integrate it first.",
    es: "Para usar esta organización, un administrador de Smart Vault tiene que haberla integrado antes.",
  },
  "organizations.role.account_admin": {
    en: "Admin",
    es: "Administrador",
  },
  "organizations.role.account_employee": {
    en: "Employee",
    es: "Empleado",
  },
  "organizations.role.seasonal_worker": {
    en: "Seasonal worker",
    es: "Trabajador temporal",
  },
  "organizations.role.assigned_employee": {
    en: "Assigned employee",
    es: "Trabajador asignado",
  },
  "organizations.selectDefault.select": {
    en: "Select",
    es: "Elegir",
  },

  "createQuoteVersionModal.header.title": {
    en: "Create a new version",
    es: "Crear una nueva versión",
  },
  "createQuoteVersionModal.header.onlyPreview": {
    en: "Do you want just a preview?",
    es: "¿Sólo quieres previsualizarlo?",
  },
  "createQuoteVersionModal.header.clickHere": {
    en: "Click here",
    es: "Pincha aquí",
  },
  "createQuoteVersionModal.header.text": {
    en: "When you click on a accepted or rejected proposal, a new version will be created. You can see changes made at version history.",
    es: "Al clicar en un presupuesto aceptado o rechazado se crea una nueva versión del mismo. Puedes ver en el historial de versiones qué ha cambiado en el presupuesto.",
  },
  "createQuoteVersionModal.form.date.error.required": {
    en: "Choose proposal date<br />",
    es: "Selecciona la fecha del presupuesto<br />",
  },
  "createQuoteVersionModal.form.date.error.noDate": {
    en: "Date is not valid<br />",
    es: "No es una fecha valida<br />",
  },
  "createQuoteVersionModal.form.date.label": {
    en: "Date",
    es: "Fecha",
  },
  "createQuoteVersionModal.form.expirationDate.label": {
    en: "Expiration date",
    es: "Válido hasta",
  },
  "createQuoteVersionModal.form.expirationDate.error.required": {
    en: "Choose proposal expiration date<br />",
    es: "Selecciona la fecha hasta que será válido el presupuesto<br />",
  },
  "createQuoteVersionModal.form.expirationDate.error.noDate": {
    en: "Date is not valid<br />",
    es: "No es una fecha válida<br />",
  },
  "createQuoteVersionModal.form.disableShared.text": {
    en: "Do you want to stop sharing the proposal with your client?",
    es: "¿Quieres dejar de compartir el presupuesto con el cliente?",
  },
  "createQuoteVersionModal.form.disableShared.noShared": {
    en: "proposal not visible to your client",
    es: "No visible para tu cliente",
  },
  "createQuoteVersionModal.form.disableShared.shared": {
    en: "proposal visible to your client",
    es: "Visible para tu cliente",
  },
  "createQuoteVersionModal.form.disableShared.info": {
    en: "Bear in mind, if shared, your client can visit the new version while you're editing it.",
    es: "Ten en cuenta que, si está compartido, tu cliente puede ver la nueva versión del presupuesto mientras lo estás editando.",
  },

  "dashboardPage.recommendedBrowser": {
    en: "Google Chrome is strongly recommended to use Quoters.",
    es: "El navegador recomendado para utilizar Quoters es Google Chrome.",
  },
  "dashboardPage.searchBar": {
    en: "Search on your proposals",
    es: "Busca entre tus presupuestos",
  },
  "dashboardPage.filterResults": {
    en: ' <i class="zmdi zmdi-filter-list"></i>&nbsp;&nbsp;Filter search results',
    es: ' <i class="zmdi zmdi-filter-list"></i>&nbsp;&nbsp;Filtrar Resultados',
  },
  "dashboardPage.filter.quotesAccepted": {
    en: "Accepted (__$1__)",
    es: "Aceptados (__$1__)",
  },
  "dashboardPage.filter.quotesRejected": {
    en: "Rejected (__$1__)",
    es: "Rechazados (__$1__)",
  },
  "dashboardPage.filter.quotesNonStatus": {
    en: "No status (__$1__)",
    es: "Sin Estado (__$1__)",
  },
  "dashboardPage.filter.include": {
    en: "Include",
    es: "Incluir",
  },

  Todos: {
    en: "All",
    es: "Todos",
  },
  "Solo Activos": {
    en: "Active only",
    es: "Solo Activos",
  },
  "Solo Archivados": {
    en: "Archived only",
    es: "Solo Archivados",
  },
  "dashboardPage.filter.proposalType": {
    en: "Proposal type",
    es: "Tipo de propuesta",
  },
  "proposalType.all": {
    en: "All",
    es: "Todos",
  },
  "proposalType.clients": {
    en: "Current clients",
    es: "Clientes actuales",
  },
  "proposalType.prospectives": {
    en: "Prospective clients",
    es: "Posibles clientes",
  },
  "dashboardPage.filter.dateFrom": {
    en: "From",
    es: "Desde",
  },
  "dashboardPage.filter.dateTo": {
    en: "to",
    es: "Hasta",
  },
  "dashboardPage.createQuote": {
    en: "+ CREATE NEW PROPOSAL",
    es: "+ CREAR NUEVO PRESUPUESTO",
  },
  "dashboardPage.orderByDate": {
    en: "Order by date",
    es: "Ordenar por fecha",
  },
  "dashboardPage.noQuotes": {
    en: 'Hey, Quoter! You haven\'t created any proposal yet!<br> Create one clicking on <a href="__$1__">new proposal.</a>',
    es: '¡Ey! ¡Aún no has creado ningún presupuesto, Quoter!<br>Si quieres crearlo haz clic en <a href="__$1__">nuevo presupuesto.</a>',
  },
  "dashboardPage.noQuotesNoFilteredQuotes": {
    en: "We couldn't find anything using those filters.<br>Wouldn't you have been using Excel for that proposal, uh? Try again!",
    es: "No hemos encontrado nada con esos filtros.<br>¿No lo habrás hecho en Excel, no? ¡Prueba otra vez!",
  },

  "dateLink.placeholder": {
    en: "Choose a date",
    es: "Selecciona una fecha",
  },
  "dateLink.closeText": {
    en: "Close",
    es: "Cerrar",
  },
  "dateLink.clearText": {
    en: "Clear",
    es: "Borrar",
  },
  "dateLink.currentText": {
    en: "Today",
    es: "Hoy",
  },
  "dateLink.selectDate": {
    en: "(Choose a date)",
    es: "(Selecciona una fecha)",
  },
  "dateLink.error.noDate": {
    en: "Choose a date",
    es: "Selecciona una fecha",
  },

  "quoteCard.accepted": {
    en: "ACCEPTED",
    es: "ACEPTADO",
  },
  "quoteCard.rejected": {
    en: "REJECTED",
    es: "RECHAZADO",
  },
  "quoteCard.prospective": {
    en: "Prospective",
    es: "Posible",
  },
  "quoteCard.onePublicView": {
    en: "One time visited",
    es: "Visto 1 vez",
  },
  "quoteCard.publicViews": {
    en: "__$1__ views",
    es: "Visto __$1__ veces",
  },
  "quoteCard.expires": {
    en: "Expires __$1__",
    es: "Vence __$1__",
  },
  "quoteCard.expired": {
    en: "EXPIRED",
    es: "VENCIDO",
  },
  "quoteCard.version": {
    en: "Version __$1__",
    es: "Versión __$1__",
  },
  "quoteCard.showVersion": {
    en: "Show v__$1__",
    es: "Ver v__$1__",
  },
  "quoteCard.activity": {
    en: "Activity",
    es: "Actividad",
  },
  "quoteCard.clientId": {
    en: "Client ID: ",
    es: "Cliente ID: ",
  },
  "quoteCard.recipients": {
    en: "Recipients",
    es: "Destinatarios",
  },
  "quoteCard.preview": {
    en: "Preview",
    es: "Previsualizar",
  },
  "quoteCard.share": {
    en: "Share",
    es: "Compartir",
  },
  "quoteCard.changeStatus": {
    en: "Change status",
    es: "Cambiar estado",
  },
  "quoteCard.moreActions": {
    en: "More actions",
    es: "Más acciones",
  },
  "quoteCard.cloneQuote": {
    en: '<i class="zmdi zmdi-copy m-r-5"></i> Clone proposal',
    es: '<i class="zmdi zmdi-copy m-r-5"></i> Duplicar presupuesto',
  },
  "quoteCard.clonedQuote": {
    en: "Copied from",
    es: "Copia de",
  },
  "quoteCard.status.accepted": {
    en: '<i class="zmdi zmdi-circle text-success m-r-5"></i> Accepted',
    es: '<i class="zmdi zmdi-circle text-success m-r-5"></i> Aceptado',
  },
  "quoteCard.status.rejected": {
    en: '<i class="zmdi zmdi-circle text-danger m-r-5"></i> Rejected',
    es: '<i class="zmdi zmdi-circle text-danger m-r-5"></i> Rechazado',
  },
  "quoteCard.archiveQuote": {
    en: '<i class="zmdi zmdi-archive m-r-5"></i> Archive proposal',
    es: '<i class="zmdi zmdi-archive m-r-5"></i> Archivar presupuesto',
  },
  "quoteCard.unarchiveQuote": {
    en: '<i class="zmdi zmdi-archive m-r-5"></i> Return to active proposals',
    es: '<i class="zmdi zmdi-archive m-r-5"></i> Devolver a presupuestos activos',
  },
  "quoteCard.deleteQuote": {
    en: '<i class="zmdi zmdi-delete m-r-5"></i> Delete',
    es: '<i class="zmdi zmdi-delete m-r-5"></i> Eliminar',
  },
  "integrationPage.header.title": {
    en: "Connect",
    es: "Vincular",
  },
  "integrationPage.header.text": {
    en: "Find here available integrations.",
    es: "Aquí encontrarás las aplicaciones con las que se puede integrar Quoters.",
  },
  "integrationCardSmartvault.needsAuthorization": {
    en: "SmartVault needs authorization. Please visit the following link:",
    es: "SmartVault necesita autorización. Por favor, visita el enlace:",
  },
  "integrationCardSmartvault.grantAccess": {
    en: "Grant Access",
    es: "Conceder autorización",
  },
  "integrationCardSmartvault.grantAccess.help": {
    en: "To continue you need to visit the link and grant permissions to QUOTERS.",
    es: "Para continuar visita el link y concede permisos a QUOTERS.",
  },
  "integrationCardSmartvault.connectionCompleted": {
    en: "SmartVault connected!",
    es: "¡Conectado a SmartVault!",
  },
  "integrationCardSmartvault.description": {
    en: "With this integration you can connect Quoters with your SmartVault account.",
    es: "Gracias a esta integración podrás integrar Quoters con tu cuenta de SmartVault.",
  },
  "integrationCardSmartvault.description.smartVaultEMail": {
    en: "Write your SmartVault account e-mail:",
    es: "Introduce el e-mail de tu cuenta de SmartVault:",
  },
  "integrationCardSmartvault.start": {
    en: "Start",
    es: "Comenzar",
  },
  "integrationCardSmartvault.yourEmailPlaceholder": {
    en: "Your SmartVault E-Mail",
    es: "Tu e-mail de SmartVault",
  },
  "integrationCardSmartvault.next": {
    en: "Next",
    es: "Continuar",
  },
  "integrationCardSmartvault.error.title": {
    en: "Error!",
    es: "¡Error!",
  },
  "integrationCardSmartvault.error.button": {
    en: "Retry",
    es: "Volver",
  },
  "integrationCardSmartvault.error.emailNotFound": {
    en: "E-mail not found. Please, enter the same e-mail of your SmartVault account.",
    es: "No se ha encontrado el e-mail. Por favor, escriba el mismo que el de su cuenta de SmartVault.",
  },
  "integrationCardSmartvault.error.generic": {
    en: "Something wrong happened, please try again later. If this problem persist, contact with your administration.",
    es: "Ha habido un error, inténtelo de nuevo más tarde. Si el problema persiste, póngase en contacto con su administrador.",
  },
  "integrationCardSmartvault.disconnect": {
    en: "Disconnect",
    es: "Desconectar",
  },
  "changeOrganizationModal.header": {
    en: "My businesses",
    es: "Mis organizaciones",
  },
  "changeOrganizationModal.defaultOrganization": {
    en: "Set as preferred",
    es: "Establecer como preferido",
  },
  "changeOrganizationModal.goToOrganization": {
    en: "Go to business",
    es: "Ir a organización",
  },
  "changeOrganizationModal.owner": {
    en: "Owner",
    es: "Dueño",
  },
  "changeOrganizationModal.guest": {
    en: "Guest",
    es: "Invitado",
  },
  "changeOrganizationModal.createOrganization": {
    en: "Create a new business",
    es: "Crear nueva organización",
  },
  "navbar.helpCenter": {
    en: '<a href="https://helpquotersio.wpenginepowered.com/" target="_blank" >Help Center</a>',
    es: '<a href="https://helpquotersio.wpenginepowered.com/es/" target="_blank" >Centro de Ayuda</a>',
  },
  "navbar.support": {
    en: '<a href="https://help.smartvault.com/hc/en-us/requests/new" target="_blank" >Support</a>',
    es: '<a href="https://help.smartvault.com/hc/en-us/requests/new" target="_blank" >Soporte</a>',
  },
  "needToPayExceptionModal.header": {
    en: "¡Sorry!",
    es: "¡Lo sentimos!",
  },
  "needToPayExceptionModal.body": {
    en: 'You can\'t use this feature as it is only available to paid clients subscribed to <strong>__$1__ Plan</strong>. But it\'s the only limitation in your trial. If you want to see features included on each plan and compare the one that fits you, click <a target="_blank" href="https://quoters.io/prices/">here.</a>',
    es: 'No puedes utilizar esta característica, ya que solo está disponible para los usuarios suscritos al <strong>Plan __$1__</strong>. Pero no te preocupes es la única limitación que tienes en tu trial. Si quieres ver qué características tiene cada plan y poder comparar qué te merece la pena haz click <a target="_blank"  href="https://quoters.io/es/precios">aquí.</a>',
  },
  "needToPayExceptionModal.goToPlans": {
    en: "Go to plans!",
    es: "¡A POR ELLO!",
  },
  "planLimitExceededModal.header": {
    en: "You need a higher plan",
    es: "¡Necesitas un plan superior!",
  },
  "planLimitExceededModal.productWithFeature": {
    en: "Do you want this feature? It's available on <strong>__$1__ Plan</strong>. __$2__",
    es: "Para poder disfrutar de esta funcionalidad tienes que suscribirte al <strong>Plan __$1__</strong>. __$2__",
  },
  "planLimitExceededModal.additionalProductWithFeature1": {
    en: "or... __$1__!",
    es: "o el... ¡__$1__!",
  },
  "planLimitExceededModal.additionalProductWithFeature2": {
    en: "Do you want this feature? It's available on <strong>__$1__ Plan</strong>.",
    es: "Para poder disfrutar de esta funcionalidad también puedes contratar el <strong>__$1__</strong>.",
  },
  "planLimitExceededModal.goToPlans": {
    en: "Go to Plans!",
    es: "¡A POR ELLO!",
  },
  "sidebar.myOrganizations": {
    en: "My businesses",
    es: "Mis organizaciones",
  },
  "sidebar.start": {
    en: "Dashboard",
    es: "Inicio",
  },
  "sidebar.newQuote": {
    en: "New proposal",
    es: "Nuevo presupuesto",
  },
  "sidebar.contacts": {
    en: "Contacts",
    es: "Contactos",
  },
  "sidebar.library": {
    en: "Library",
    es: "Biblioteca",
  },
  "sidebar.tariffs": {
    en: "Rates",
    es: "Tarifas",
  },
  "sidebar.costs": {
    en: "Costs",
    es: "Costes",
  },
  "sidebar.settings": {
    en: "Settings",
    es: "Ajustes",
  },
  "sidebar.link": {
    en: "Connect",
    es: "Vincular",
  },
  "sidebar.blog": {
    en: '<a target="_blank" href="https://quoters.io/blog" >Blog</a>',
    es: '<a target="_blank" href="https://quoters.io/es/blog" >Blog</a>',
  },
  "contactCard.editContact": {
    en: "Edit contact",
    es: "Editar contacto",
  },
  "contactCard.removeContact": {
    en: "Remove contact",
    es: "Borrar contacto",
  },
  "contactModal.header.new": {
    en: "New contact",
    es: "Nuevo contacto",
  },
  "contactModal.header.edit": {
    en: "Edit contact",
    es: "Editar contacto",
  },
  "contactModal.form.name": {
    en: "First Name",
    es: "Nombre*",
  },
  "contactModal.form.middleName": {
    en: "Middle Name",
    es: "Segundo nombre",
  },
  "contactModal.form.lastName": {
    en: "Last name",
    es: "Apellidos",
  },
  "contactModal.form.email": {
    en: "Email",
    es: "Email",
  },
  "contactModal.form.email.error.alreadyExists": {
    en: "Contact with same email already exists",
    es: "Ya existe un contacto con este email",
  },
  "contactModal.form.additionalData": {
    en: "Add more information",
    es: "Completar más datos",
  },
  "contactModal.form.company": {
    en: "Business",
    es: "Empresa",
  },
  "contactModal.form.appointment": {
    en: "Job title",
    es: "Cargo",
  },
  "contactModal.form.nif": {
    en: "ID/Tax no.",
    es: "NIF",
  },
  "contactModal.form.primaryPhone": {
    en: "Primary phone no.",
    es: "Teléfono Principal",
  },
  "contactModal.form.secondaryPhone": {
    en: "Secondary phone no.",
    es: "Teléfono Secundario",
  },
  "contactModal.form.addressLine1": {
    en: "Address",
    es: "Dirección",
  },
  "contactModal.form.addressLine2": {
    en: "Address (Addtional information)",
    es: "Dirección (datos adicionales)",
  },
  "contactModal.form.zipOrPostalCode": {
    en: "Postal code",
    es: "Código Postal",
  },
  "contactModal.form.city": {
    en: "City",
    es: "Población",
  },
  "contactModal.form.stateOrProvince": {
    en: "State or province",
    es: "Provincia o Estado",
  },
  "contactModal.form.country": {
    en: "Country",
    es: "País",
  },
  "contactModal.form.currency": {
    en: "Currency",
    es: "Divisa",
  },
  "contactModal.form.currency.tooltip": {
    en: "Default currency for this contact",
    es: "Divisa por defecto para este contacto",
  },
  "contactModal.form.submit": {
    en: "Save contact",
    es: "Guardar contacto",
  },
  "libraryContactsPage.title": {
    en: "Contacts",
    es: "Tus contactos",
  },
  "libraryContactsPage.header": {
    en: "Find the people who you're going to send the proposals. Create new contacts or edit your contacts.",
    es: "Encuentra a las personas a las que enviarás tus presupuestos. Crea nuevos contactos o edita los que ya tienes.",
  },
  "libraryContactsPage.newContact": {
    en: "New contact",
    es: "Nuevo Contacto",
  },
  "libraryContactsPage.search.placeholder": {
    en: "Search on your contacts",
    es: "Buscar entre tus contactos",
  },
  "libraryContactsPage.searchResults": {
    en: "Search results: ",
    es: "Resultados de la búsqueda:",
  },
  "libraryContactsPage.noResults": {
    en: "Ouch! We couldn't find any contact with that description. <br> Try again!",
    es: "¡Ouch! No hemos encontrado ningún contacto con esa descripción.<br>¡Prueba otra vez!",
  },
  "libraryContactsPage.noContacts": {
    en: "No contacts yet!<br>You can create a new one clicking on the right button<br> and start sending winning proposals.",
    es: "¡Sin contacto de los contactos!<br>Crea uno nuevo pinchando en el botón de la derecha<br>y comienza a enviar presupuestos ganadores.",
  },
  "costModal.header": {
    en: "Cost",
    es: "Coste",
  },
  "costModal.form.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },
  "costModal.form.name.error": {
    en: "Duplicated name",
    es: "Nombre duplicado",
  },
  "costModal.form.unit.placeholder": {
    en: "Unit",
    es: "Und. de medida",
  },
  "costModal.form.unit.error.required": {
    en: "Type cost unit (e.g: units, hours, metres, etc..)<br />",
    es: "Escribe la unidad de medida del coste (Ej: unidades, horas, metros, etc...)<br />",
  },
  "costModal.form.price.placeholder": {
    en: "Price",
    es: "Precio",
  },
  "costModal.form.price.error.number": {
    en: "It has to be a number<br />",
    es: "Debe ser un número<br />",
  },
  "costModal.form.price.error.min": {
    en: "It has to be positive<br />",
    es: "Debe ser positivo<br />",
  },
  "costModal.form.price.error.max": {
    en: "The maximum valid amount is 9,999,999,999.99",
    es: "El valor máximo aceptado es 9,999,999,999.99",
  },
  "costModal.form.price.error.maxLength": {
    en: "It's too long (max: 9,999,999,999.99)<br />",
    es: "Demasiado largo (max: 9.999.999.999,99)<br />",
  },
  "costModal.form.comments.placeholder": {
    en: "Comments",
    es: "Notas relacionadas con el coste",
  },
  "importTariffCsvModal.header.title": {
    en: "Import Rates using a CSV file",
    es: "Importar Tarifas en CSV",
  },
  "importTariffCsvModal.header.templateLink": {
    en: "Download rates CSV template",
    es: "Descargar plantilla de tarifas en csv",
  },
  "importTariffCsvModal.header.tooltip": {
    en: "You can download a compatible template in .csv format and edit your rates on it",
    es: "Puedes descargar una plantilla compatible en formato .csv y editar tus tarifas sobre ella",
  },
  "importTariffCsvModal.body.selectFile": {
    en: "Choose a file",
    es: "Seleccionar archivo",
  },
  "importTariffCsvModal.body.import": {
    en: "Import CSV",
    es: "Importar CSV",
  },
  "importTariffCsvModal.error.message": {
    en: "The following CSV lines had errors and couldn't be saved:",
    es: "Las siguientes líneas del CSV presentan errores y no se han guardado:",
  },
  "importTariffCsvModal.error.line": {
    en: "Line __$1__, in field: __$2__.",
    es: "Línea __$1__, en el campo: __$2__.",
  },
  "importTariffCsvModal.body.restartImport": {
    en: "Retry",
    es: "Volver a intentar",
  },
  "importCostsCsvModal.header.title": {
    en: "Import Costs using a CSV file",
    es: "Importar Costes en CSV",
  },
  "importCostsCsvModal.header.templateLink": {
    en: "Download costs CSV template",
    es: "Descargar plantilla de costes en csv",
  },
  "importCostsCsvModal.header.orUseYourData": {
    en: "or use your CSV downloaded data",
    es: "o utiliza el CSV con tus datos",
  },
  "importCostsCsvModal.header.tooltip": {
    en: "You can download a compatible template in .csv format and edit your costs on it",
    es: "Puedes descargar una plantilla compatible en formato .csv y editar tus costes sobre ella",
  },
  "importCostsCsvModal.body.selectFile": {
    en: "Choose a file",
    es: "Seleccionar archivo",
  },
  "importCostsCsvModal.body.howTo": {
    en: "How to import:",
    es: "Cómo importar:",
  },
  "importCostsCsvModal.body.import": {
    en: "Import CSV",
    es: "Importar CSV",
  },
  "importCostsCsvModal.body.instructions": {
    en: "<li>Add your cost data to the CSV template, and be sure to provide the following fields:<ul><li>ID (only at editing downloaded data)</li><li>Name</li><li>Unit</li><li>Price</li><li>Currency (ISO code)</li><li>Comments (optional)</li></ul><br />Note: If using Excel, make sure to export or save the file as a .csv</li><li>Updload it below and click <strong>Import</strong> for processing</li>",
    es: "<li>Añade la información de tus costes a la plantilla de CSV y asegúrate de rellenar los siguientes campos: <ul><li>ID (solo cuando se edita datos descargados)</li><li>Nombre</li><li>Unidad</li><li>Precio</li><li>Moneda (código ISO)</li><li>Comentarios (opcional)</li></ul><br />Nota: Si utilizas Excel, asegúrate de exportar o guardar el archivo como .csv</li><li>Sube el archivo a continuación y clica en <strong>Importar</strong> para que se procese</li>",
  },
  "libraryCostsPage.costs": {
    en: "Costs",
    es: "Costes",
  },
  "libraryCostsPage.description": {
    en: "Save and categorize all your costs, that will help you to be more profitable.",
    es: "Aquí podrás almacenar y categorizar todos tus costes, lo que te ayudará a ser más rentable.",
  },
  "libraryCostsPage.importCsv": {
    en: "Import costs",
    es: "Importar costes",
  },
  "libraryCostsPage.importCsv.tooltip": {
    en: "Import your costs in CSV format",
    es: "Impota tus costes en CSV",
  },
  "libraryCostsPage.newCost": {
    en: "New cost",
    es: "Nuevo coste",
  },
  "libraryCostsPage.search": {
    en: "Search cost",
    es: "Buscar entre tus costes",
  },
  "libraryCostsPage.searchResults": {
    en: "Search results:",
    es: "Resultados de la búsqueda:",
  },
  "libraryCostsPage.noResults": {
    en: "Ouch! We couldn't find any cost with that description.<br>Try again!",
    es: "¡Ouch! No hemos encontrado ningún coste con esa descripción.<br>¡Prueba otra vez!",
  },
  "libraryCostsPage.downloadCsv": {
    en: "Download CSV",
    es: "Descargar CSV",
  },
  "libraryCostsPage.noCostsYet": {
    en: 'There is no cost yet!<br>Would you like to learn how to create them? <a href="http://help.quoters.io/manage-your-business-costs" target="_blank">Read this article.</a>',
    es: '¡Aún no tienes costes, Quoter!<br>¿Quieres aprender a crear uno? <a href="http://help.quoters.io/es/crear-y-editar-un-presupuesto/crear-costes" target="_blank">Lee este artículo.</a>',
  },
  "selectCostModal.header": {
    en: "Choose a cost",
    es: "Selecciona un coste",
  },
  "selectCostModal.search.placeholder": {
    en: "Search on your costs",
    es: "Buscar entre tus costes",
  },
  "selectCostModal.newCost": {
    en: "New cost",
    es: "Nuevo coste",
  },
  "selectCostModal.searchResults": {
    en: "Search results:",
    es: "Resultados de la búsqueda:",
  },
  "selectCostModal.noResults": {
    en: "Ouch! We couldn't find any cost with that description.<br>Try again!",
    es: "¡Ouch! No hemos encontrado ningún coste con esa descripción <br>¡Prueba otra vez!",
  },
  "selectCostModal.noCostsYet": {
    en: 'There is no cost yet!<br>Would you like to learn how to create them? <a href="https://help.quoters.io/knowledgebase/manage-your-business-costs" target="_blank">Read this article.</a>',
    es: '¡Aún no tienes costes, Quoter!<br>¿Quieres aprender a crear uno? <a href="https://help.quoters.io/es/crear-y-editar-un-presupuesto/crear-costes" target="_blank">Lee este artículo.</a>',
  },
  "selectCostModal.showMore": {
    en: "Show more",
    es: "Ver más",
  },
  "libraryTariffsPage.importCsv": {
    en: "Import rates",
    es: "Importar tarifas",
  },
  "libraryTariffsPage.importCsv.tooltip": {
    en: "Import your rates in CSV format",
    es: "Impota tus tarifas en CSV",
  },
  "importTariffsCsvModal.header.orUseYourData": {
    en: "or use your CSV downloaded data",
    es: "o utiliza el CSV con tus datos",
  },
  "importTariffsCsvModal.error.message": {
    en: "The following CSV lines had errors and couldn't be saved:",
    es: "Las siguientes líneas del CSV presentan errores y no se han guardado:",
  },
  "importTariffsCsvModal.error.line": {
    en: "Line __$1__. Please, provide a valid __$2__.",
    es: "Línea __$1__. Por favor, ingrese un __$2__ válido.",
  },
  "importTariffsCsvModal.body.howTo": {
    en: "How to import:",
    es: "Cómo importar:",
  },
  "importTariffsCsvModal.body.restartImport": {
    en: "Retry",
    es: "Volver a intentar",
  },
  "importTariffsCsvModal.body.instructions": {
    en: "<li>Add your rate data to the CSV template, and be sure to provide the following fields:<ul><li>ID (only at editing downloaded data)</li><li>Description</li><li>Price</li></ul><br />Note: If using Excel, make sure to export or save the file as a .csv</li><li>Updload it below and click <strong>Import</strong> for processing</li>",
    es: "<li>Añade la información de tus tarifas a la plantilla de CSV y asegúrate de rellenar los siguientes campos: <ul><li>ID (solo cuando se edita datos descargados)</li><li>Descripción</li><li>Precio</li></ul><br />Nota: Si utilizas Excel, asegúrate de exportar o guardar el archivo como .csv</li><li>Sube el archivo a continuación y clica en <strong>Importar</strong> para que se procese</li>",
  },
  "importTariffsCsvModal.header.templateLink": {
    en: "Download rates CSV template",
    es: "Descargar plantilla de tarifas en csv",
  },
  "importTariffsCsvModal.header.tooltip": {
    en: "You can download a compatible template in .csv format and edit your rates on it",
    es: "Puedes descargar una plantilla compatible en formato .csv y editar tus tarifas sobre ella",
  },
  "libraryTariffsPage.manageTariffs": {
    en: "Manage your rates",
    es: "Gestiona tus tarifas",
  },
  "libraryTariffsPage.description": {
    en: "Here, you can find the rates that you created. Reuse, edit or create a new one.",
    es: "Aquí encontrarás las tarifas que hayas creado. Reutiliza, edita o crea una nueva.",
  },
  "libraryTariffsPage.downloadCsv": {
    en: "Download CSV",
    es: "Descargar CSV",
  },
  "libraryTariffsPage.newTariff": {
    en: "New rate",
    es: "Nueva tarifa",
  },
  "libraryTariffsPage.search.placeholder": {
    en: "Search on your rates",
    es: "Buscar entre tus tarifas",
  },
  "libraryTariffsPage.searchResults": {
    en: "Search results: ",
    es: "Resultados de la búsqueda:",
  },
  "libraryTariffsPage.noResults": {
    en: "Ouch! We couldn't find any rate with that description.<br>Try again!",
    es: "¡Ouch! No hemos encontrado ninguna tarifa con esa descripción.<br>¡Prueba otra vez!",
  },
  "libraryTariffsPage.noTariffsYet": {
    en: 'There is no rate yet!<br>Would you like to learn how to create them? <a href="https://help.quoters.io/knowledgebase/manage-rates" target="_blank">Read this article.</a>',
    es: '¡Aún no tienes tarifas, Quoter!<br>¿Quieres aprender a crear uno? <a href="https://help.quoters.io/es/crear-y-editar-un-presupuesto/crear-tarifas" target="_blank">Lee este artículo.</a>',
  },
  "libraryTariffsPage.costOnTariff.placeholder": {
    en: "This rate has related costs",
    es: "Esta tarifa tiene costes asociados",
  },
  "tariffForm.newTariff": {
    en: "New rate",
    es: "Nueva tarifa",
  },
  "tariffForm.description.label": {
    en: "Description",
    es: "Descripción o concepto",
  },
  "tariffForm.margin.label": {
    en: "Markup",
    es: "Margen",
  },
  "tariffForm.margin.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "tariffForm.margin.error.max": {
    en: "The maximum valid amount is 9,999,999,999.99",
    es: "El valor máximo aceptado es 9,999,999,999.99",
  },
  "tariffForm.description.error.duplicate": {
    en: "Duplicated description<br/>",
    es: "Descripción duplicada<br/>",
  },
  "tariffForm.price.label": {
    en: "Price",
    es: "Precio",
  },
  "tariffForm.price.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "tariffForm.price.error.min": {
    en: "It has to be positive or zero<br/>",
    es: "Debe ser positivo o cero<br/>",
  },
  "tariffForm.price.error.max": {
    en: "The maximum valid amount is 9,999,999,999.99",
    es: "El valor máximo es 9,999,999,999.99",
  },
  "tariffForm.addCosts.label": {
    en: "Add costs related with the rate",
    es: "Añade costes relacionados con la tarifa",
  },
  "tariffForm.addCosts.add": {
    en: "Add a new cost",
    es: "Añadir un nuevo coste",
  },
  "tariffForm.addCosts.quantity.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "tariffForm.addCosts.quantity.error.min": {
    en: "It has to be positive<br/>",
    es: "Debe ser positivo<br/>",
  },
  "tariffForm.addCosts.quantity.error.max": {
    en: "The maximum valid amount is 9,999,999,999.99",
    es: "El valor máximo es is 9,999,999,999.99",
  },
  "tariffForm.addCosts.quantity.error.maxLength": {
    en: "It is too long (max: 9.999.999.99)<br/>",
    es: "Demasiado largo (max: 9.999.999.99)<br/>",
  },
  "brandingSettings.description": {
    en: "Welcome to the brand centre. On it you can set up the main elements of the look and feel of your proposals: Choose the best font for your proposals and the corporate colors that will make you sell more and better.",
    es: "Bienvenido al centro de tu marca. Aquí podrás configurar los elementos principales de la imagen de tus presupuestos: Elige la mejor fuente para tus presupuestos y los colores corporativos que te harán vender más y mejor.",
  },
  "brandingSettings.font": {
    en: "Font",
    es: "Fuente",
  },
  "brandingSettings.config.title": {
    en: "Title",
    es: "Título",
  },
  "brandingSettings.config.subtitle": {
    en: "Subtitle",
    es: "Subtítulo",
  },
  "brandingSettings.config.paragraph": {
    en: "Paragraph",
    es: "Párrafo",
  },
  "brandingSettings.config.color": {
    en: "Colour",
    es: "Color",
  },
  "brandingSettings.config.main": {
    en: "Main",
    es: "Principal",
  },
  "brandingSettings.config.secondary": {
    en: "Secondary",
    es: "Secundario",
  },
  "cancelAdditionalUsersModal.header": {
    en: "Cancel extra users",
    es: "Eliminar usuarios extra",
  },
  "cancelAdditionalUsersModal.removeExtraUsers": {
    en: "Remove users",
    es: "Quitar usuarios",
  },
  "cancelAdditionalUsersModal.error.min": {
    en: "Minimum value is 1",
    es: "El valor mínimo es 1",
  },
  "cancelAdditionalUsersModal.error.max": {
    en: "Maximum value is __$1__",
    es: "El valor máximo es __$1__",
  },
  "cancelAdditionalUsersModal.error.step": {
    en: "Value has to be an integer number",
    es: "El valor debe ser un número entero",
  },
  "cancelAdditionalUsersModal.submit": {
    en: "Next",
    es: "Continuar",
  },
  "collectPaymentMethodModal.header": {
    en: "Payment method",
    es: "Método de pago",
  },
  "customDomainSettings.current": {
    en: "<strong>Your current domain for the public view is:</strong><br>",
    es: "<strong>Tu dominio actual para la vista pública es:</strong><br>",
  },
  "customDomainSettings.newDomain": {
    en: "<strong>Your new domain will be:</strong><br>",
    es: "<strong>Tu nuevo dominio será:</strong><br>",
  },
  "customDomainSettings.verifying": {
    en: "<strong>Verifying...</strong>",
    es: "<strong>Verificando...</strong>",
  },
  "customDomainSettings.pending": {
    en: "PENDING",
    es: "PENDIENTE",
  },
  "customDomainSettings.ok24Hours": {
    en: "<small>Well done! Domain has been sucessfully configured and will be active within 24 hours.</small>",
    es: "<small>¡Bien! La configuración es correcta. En un máximo de 24 horas tu nuevo dominio estará activo.</small>",
  },
  "customDomainSettings.error.label": {
    en: "ERROR",
    es: "ERROR",
  },
  "customDomainSettings.error.description": {
    en: "<small>Oops! Something went wrong. Please check your CNAME settings on your domain provider.</small>",
    es: "<small>¡Ups! Algo ha salido mal. Revisa tu configuración de DNS de tipo CNAME.</small>",
  },
  "customDomainSettings.newDnsRecord": {
    en: "Now, add a new DNS record of type CNAME with this value:",
    es: "Ahora añade un nuevo registro DNS de tipo CNAME apuntando a:",
  },
  "customDomainSettings.description": {
    en: 'If you don\'t want your clients to see "quoters.io" in the public URL of your budgets, you can set up your own domain. For example, you can use proposals.yourdomain.com. For further information on how to configure a custom domain, visit <a target="_blank" href="https://help.quoters.io/knowledgebase/set-up-your-custom-domain/"> this article </a> from our Help Center.',
    es: 'Si no quieres que tus clientes vean "quoters.io" en la URL pública de tus presupuestos, puedes configurar un dominio propio. Por ejemplo, puedes utilizar presupuestos.tudominio.com. Si quieres más información sobre cómo se configura un dominio personalizado, consulta <a target="_blank" href="https://help.quoters.io/es/knowledgebase/cambiar-dominio/">este artículo</a> de nuestro Centro de Ayuda.',
  },
  "customDomainSettings.helpCenterPost": {
    en: 'Visit <a target="_blank" href="https://help.quoters.io/knowledgebase/set-up-your-custom-domain/"> this article </a> of our Help Center for further information. Change will be effective in about 24 hours, so your previous domain for public views of your proposals is still available.',
    es: 'Consulta <a target="_blank" href="https://help.quoters.io/es/knowledgebase/cambiar-dominio/">este artículo</a> de nuestro Centro de Ayuda para más información. El cambio se hará efectivo en unas 24 horas, así que aún conservas el anterior dominio para las vistas públicas de tus presupuestos.',
  },
  "customDomainSettings.verify": {
    en: "Verify settings",
    es: "Verificar configuración",
  },
  "customDomainSettings.requestedCustomDomain": {
    en: "If you want to change your domain again, do it on the field below. You can also reset to Quoters default domain.",
    es: "Si quieres  cambiar tu dominio de nuevo, solicítalo en el campo a continuación. También puedes restablecer el dominio por defecto de Quoters.",
  },
  "customDomainSettings.typeDomain": {
    en: "Type your new domain for your proposals here:",
    es: "Escribe aquí tu nuevo dominio para tus presupuestos:",
  },
  "customDomainSettings.resetToDefault": {
    en: "Reset domain to default",
    es: "Restablecer dominio por defecto",
  },
  "customDomainSettings.form.customDomainUrl.placeholder": {
    en: "e.g: proposals.yourdomain.com",
    es: "Ejemplo: presupuestos.tudominio.com",
  },
  "customDomainSettings.form.customDomainUrl.error.validateDomain": {
    en: "Invalid domain<br />",
    es: "Escribe un nombre de dominio válido<br />",
  },
  "customDomainSettings.form.submit": {
    en: "Request",
    es: "Solicitar",
  },
  "organizationProfile.form.name.label": {
    en: "Business Name",
    es: "Nombre de tu organización",
  },
  "organizationProfile.form.name.placeholder": {
    en: "e.g: ACME Corp",
    es: "Ejemplo: ACME S.A.",
  },
  "organizationProfile.form.url.label": {
    en: "URL",
    es: "URL",
  },
  "organizationProfile.form.url.error.required": {
    en: "La url de la organización es obligatoria<br />",
    es: "Organization url is required<br />",
  },
  "organizationProfile.form.url.error.pattern": {
    en: "Only lowercase letters, numbers, and hyphens<br/>",
    es: "Solo minúsculas, números, y guiones<br/>",
  },
  "organizationProfile.form.url.error.uniqueSlug": {
    en: "This slug was already used<br/>",
    es: "Este slug ya ha sido utilizado<br/>",
  },
  "organizationProfile.form.addressLine1.label": {
    en: "Address",
    es: "Dirección",
  },
  "organizationProfile.form.addressLine1.placeholder": {
    en: "e.g: 4 Pennsylvania Plaza",
    es: "Ejemplo: Plaza Mayor 5, 4ºD",
  },
  "organizationProfile.form.addressLine2.label": {
    en: "Address (Additional Information)",
    es: "Dirección (datos adicionales)",
  },
  "organizationProfile.form.addressLine2.placeholder": {
    en: "e.g: Madison Square Garden",
    es: "Ejemplo: Edificio de usos múltiples.",
  },
  "organizationProfile.form.zipOrPostalCode.label": {
    en: "Postal Code",
    es: "Código postal",
  },
  "organizationProfile.form.zipOrPostalCode.placeholder": {
    en: "e.g: 10001",
    es: "Ejemplo: 47003",
  },
  "organizationProfile.form.city.label": {
    en: "City",
    es: "Ciudad",
  },
  "organizationProfile.form.city.placeholder": {
    en: "e.g: New York City",
    es: "Ejemplo: Valladolid",
  },
  "organizationProfile.form.stateOrProvince.label": {
    en: "State or Province",
    es: "Provincia/Región",
  },
  "organizationProfile.form.stateOrProvince.placeholder": {
    en: "e.g: New York",
    es: "Ejemplo: Valladolid",
  },
  "organizationProfile.form.country.label": {
    en: "Country",
    es: "País",
  },
  "organizationProfile.form.country.placeholder": {
    en: "Choose a country",
    es: "Selecciona un país",
  },
  "organizationProfile.form.web.label": {
    en: "Web",
    es: "Web",
  },
  "organizationProfile.form.web.placeholder": {
    en: "e.g: https://quoters.io",
    es: "Ejemplo: https://quoters.io",
  },
  "organizationProfile.form.phone.label": {
    en: "Primary Phone Number",
    es: "Teléfono",
  },
  "organizationProfile.form.phone.placeholder": {
    en: "e.g: 212.465.6000",
    es: "Ejemplo: 983 02 65 89",
  },
  "organizationProfile.form.submit": {
    en: "Update",
    es: "Actualizar",
  },
  "organizationSettingsPage.header.title": {
    en: "Settings",
    es: "Tus ajustes",
  },
  "organizationSettingsPage.header.description": {
    en: "Modify your business settings: business information, team, look and feel of your proposals.",
    es: "Aquí podrás modificar la configuración de tu organización: datos del negocio, equipo y apariencia de tus presupuestos.",
  },
  "organizationSettingsPage.updateImage": {
    en: "Update business logo",
    es: "Actualizar foto de la organización",
  },
  "organizationSettingsPage.updateImage.recommendedSize": {
    en: "Recommended image size is 400x300 pixels",
    es: "El tamaño de la imagen recomendado es 400x300 píxels",
  },
  "organizationSettingsPage.info": {
    en: "Information",
    es: "Datos",
  },
  "organizationSettingsPage.info.tooltip": {
    en: "Fill the basic contact information of your business.",
    es: "Rellena la información básica de contacto de tu empresa.",
  },
  "organizationSettingsPage.customFields": {
    en: "Custom Fields",
    es: "Campos personalizados",
  },
  "organizationSettingsPage.customFields.tooltip": {
    en: "Create custom fields for this organization's proposals",
    es: "Crea campos personalizados para los presupuestos de esta organización",
  },
  "organizationSettingsPage.users": {
    en: "Users",
    es: "Usuarios",
  },
  "organizationSettingsPage.users.tooltip": {
    en: "Do you prefer to work in a team? Invite your fellow coworkers and co-create proposals.",
    es: "¿Prefieres trabajar en equipo? Invita a tus colaboradores y cread presupuestos juntos.",
  },
  "organizationSettingsPage.quotes": {
    en: "Proposals",
    es: "Presupuestos",
  },
  "organizationSettingsPage.quotes.tooltip": {
    en: "Set up the defaults for your proposals: currency, language, taxes...",
    es: "Configura los datos generales de tus presupuestos: divisa, idioma, impuestos...",
  },
  "organizationSettingsPage.lookAndFeel": {
    en: "Look and Feel",
    es: "Apariencia",
  },
  "organizationSettingsPage.lookAndFeel.tooltip": {
    en: "Do you want your proposals to be nice? This is the place to do so.",
    es: "¿Quieres que tus presupuestos sean bonitos? Este es el lugar para hacerlo.",
  },
  "organizationSettingsPage.customDomain": {
    en: "Custom domain",
    es: "Dominio",
  },
  "organizationSettingsPage.customDomain.tooltip": {
    en: "Set up your own domain so your proposals can be an extension of your website",
    es: "Configura el dominio para que tus presupuestos sean una extensión de tu web",
  },
  "settings.region.title": {
    en: "Region Settings",
    es: "Configuración Regional",
  },
  "settings.region.description": {
    en: "In this section you can set up Quoters language, timezone and currency.",
    es: "En esta sección puedes definir el idioma de la aplicación, la zona horaria y la divisa.",
  },
  "settings.region.language": {
    en: "Language",
    es: "Idioma",
  },
  "settings.region.dateFormat": {
    en: "Date format",
    es: "Formato de fecha",
  },
  "settings.region.timezone": {
    en: "Timezone",
    es: "Zona horaria",
  },
  "currencySelector.current": {
    en: "Saved currency",
    es: "Divisa guardada",
  },
  "settings.region.currency": {
    en: "Currency",
    es: "Divisa",
  },
  "organizationProfile.region.submit": {
    en: "Save region settings",
    es: "Guardar configuración regional",
  },
  "settings.quote.valid.title": {
    en: "Proposals expiration (days)",
    es: "Validez de los presupuestos",
  },
  "settings.quote.valid.description": {
    en: "Set up a default expiration time for proposal, so you won't have to worry about setting the expiration date every time you create a new proposal. Quoters will do it for you.",
    es: "Te permite establecer el periodo de validez por defecto de un presupuesto, así no tendrás que preocuparte de poner la fecha de validez cada vez que crees un nuevo presupuesto, nosotros lo haremos por ti.",
  },
  "settings.quote.series.title": {
    en: "Proposal number",
    es: "Número del presupuesto",
  },
  "settings.quote.series.description": {
    en: "Proposal number is used to identify a proposal. A proposal number is made up of a prefix followed by a number that is sequential and automatically incremented each time you create a new proposal.",
    es: "El número de presupuesto sirve para identificar un presupuesto. Un número de presupuesto se compone de un prefijo seguido por un número que es secuencial y se incrementa automáticamente cada vez que creas un nuevo presupuesto.",
  },
  "settings.quote.series.prefix": {
    en: "Prefix",
    es: "Prefijo",
  },
  "settings.quote.series.nextNumber": {
    en: "Following proposal number",
    es: "Número siguiente",
  },
  "settings.quote.series.default": {
    en: "By default",
    es: "Por defecto",
  },
  "settings.quote.emailToCustomerOnAccept.title": {
    en: "Acceptance Email",
    es: "Email de aceptación",
  },
  "settings.quote.emailToCustomerOnAccept.description": {
    en: "Send a default email your clients when they accept your proposal.",
    es: "Envía un correo por defecto a tus clientes cuando aprueban tus presupuestos.",
  },
  "settings.quote.language.title": {
    en: "Proposals language",
    es: "Idioma de los presupuestos",
  },
  "settings.quote.language.description": {
    en: "It allows you to set default proposal language. Pricing table header and proposal public view will change to this language.",
    es: "Te permite establecer el idioma por defecto de tus presupuestos. Las cabeceras de la tabla de precios y la previsualización cambiarán al idioma establecido.",
  },
  "settings.quote.signature.title": {
    en: "Proposals signature",
    es: "Firma de los presupuestos",
  },
  "settings.quote.signature.description": {
    en: "Set the name of the person who will sign the proposals for your business and upload his/her signature as an image. Ratio for image is 4:3.",
    es: "Define el nombre del responsable que va a firmar los presupuestos y sube su firma en una imagen. La proporción utilizada es de 4:3.",
  },
  "settings.quote.approveFromPublicView.title": {
    en: "Accept Proposals",
    es: "Aceptar presupuestos",
  },
  "settings.quote.approveFromPublicView.description": {
    en: 'It allows you to set by default the "Accept" button on public view whenever you create a new proposal.',
    es: 'Te permite establecer si el botón de "Aceptar" presupuesto en la vista pública está disponible por defecto al crear un nuevo presupuesto.',
  },
  "settings.quote.pdfDownloadable.title": {
    en: "PDF downloadable by client",
    es: "PDF descargable por el cliente",
  },
  "settings.quote.pdfDownloadable.description": {
    en: "It allows you to set by default pdf downloadable by client whenever you create a new proposal.",
    es: "Te permite establecer si la descarga del pdf por el cliente está disponible por defecto al crear un nuevo presupuesto.",
  },
  "settings.quote.taxes.title": {
    en: "Taxes",
    es: "Impuestos",
  },
  "settings.quote.taxes.description": {
    en: "In this section you can set taxes so that you have them available when you are editing pricing tables of your proposals.",
    es: "En esta sección puedes definir tus impuestos para que los tengas disponibles cuando estás haciendo tu tabla de precios en el presupuesto.",
  },
  "settingsExpirationDate.form.label": {
    en: "Days",
    es: "Días",
  },
  "settingsExpirationDate.form.error.number": {
    en: "Time limit has to be a number<br/>",
    es: "El periodo de validez debe ser un número<br/>",
  },
  "settingsExpirationDate.form.error.min": {
    en: "Time period has to be higher</br>",
    es: "Periodo de validez debe ser mayor<br/>",
  },
  "settingsExpirationDate.form.error.max": {
    en: "Time limit is too high<br/>",
    es: "Periodo de validez demasiado prolongado<br/>",
  },
  "settingsExpirationDate.form.submit": {
    en: "Update",
    es: "Actualizar",
  },
  "settingsQuoteNumberRow.form.number.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "settingsQuoteNumberRow.form.number.error.min": {
    en: "It's too low (min: 1)<br/>",
    es: "Demasiado pequeño (min: 1)<br/>",
  },
  "settingsQuoteNumberRow.form.number.error.max": {
    en: "The maximum valid amount is 9,999,999,999.99",
    es: "El valor máximo aceptado es 9,999,999,999.99",
  },
  "settingsQuoteNumberRow.form.number.error.valueGreaterOrEqualThan": {
    en: "It has to be equal or higher than __$1__<br/>",
    es: "Debe ser mayor o igual que __$1__<br/>",
  },
  "settingsSignature.title": {
    en: "Signature",
    es: "Responsable de la firma",
  },
  "settingsSignature.form.contact.error.minLength": {
    en: "It has to be longer than 3 characters<br />",
    es: "Debe de tener más de 3 caracteres<br />",
  },
  "settingsSignature.form.contact.submit": {
    en: "Upload signature",
    es: "Subir Firma",
  },
  "settingsSignature.signatureDefault.tooltip": {
    en: "Required by default on proposal creation",
    es: "Firma requerida por defecto al crear un presupuesto",
  },
  "settingsTaxes.name": {
    en: "Tax name",
    es: "Nombre",
  },
  "settingsTaxes.percentage": {
    en: "Percentage",
    es: "Porcentaje",
  },
  "settingsTaxes.default": {
    en: "By default",
    es: "Por defecto",
  },
  "settingsTaxes.new": {
    en: "New",
    es: "Nuevo",
  },
  "settingsTaxesRow.form.percentage.error.number": {
    en: "It has to be a number<br />",
    es: "Debe ser un número<br />",
  },
  "settingsTaxesRow.form.percentage.error.min": {
    en: "It is too low (min: -100)<br />",
    es: "Demasiado pequeño (min: -100)<br />",
  },
  "settingsTaxesRow.form.percentage.error.max": {
    en: "It is too high (max: 100)<br />",
    es: "Demasiado grande (max: 100)<br />",
  },
  "settingsTeam.inviteToOrganization": {
    en: "Invite to business",
    es: "Invitar a la organización",
  },
  "settingsTeam.form.email.placeholder": {
    en: "Email",
    es: "Email",
  },
  "settingsTeam.form.email.error.email": {
    en: "Type a valid email (your.name@domain.com)<br/>",
    es: "Escribe un email válido (ejemplo@ejemplo.com)<br/>",
  },
  "settingsTeam.form.email.error.validateSome": {
    en: "This email has already been invited<br/>",
    es: "Este email ya ha sido invitado<br/>",
  },
  "settingsTeam.form.submit": {
    en: "Invite",
    es: "Invitar",
  },
  "settingsTeam.organizationUsers": {
    en: "Users on the business",
    es: "Usuarios de la organización",
  },
  "settingsTeam.organizationUsers.status": {
    en: "There's __$1__ of your SmartVault's account members connected to Quoters.",
    es: "Hay __$1__ miembros de tu organización de SmartVault conectados a Quoters.",
  },
  "settingsTeam.organizationUsers.ownerPermissions": {
    en: "Admin access",
    es: "Permisos de administrador",
  },
  "settingsTeam.organizationUsers.ownerPermissions.tooltip": {
    en: "Admin access will allow user to get into settings window and modify all options. This will affect your business. ",
    es: "Los permisos de administrador permitirán al usuario acceder a la ventana de ajustes y modificar todas las opciones. Esto afectará a toda la organización.",
  },
  "settingsTeam.organizationUsers.role": {
    en: "Role",
    es: "Rol",
  },
  "settingsTeam.organizationUsers.invitedAt": {
    en: "Invited on __$1__",
    es: "Invitado el __$1__",
  },
  "settingsTeam.organizationUsers.resendInvitation": {
    en: "Resend invitation",
    es: "Reenviar invitación",
  },
  "settingsTeam.organizationUsers.owner": {
    en: "Owner",
    es: "Propietario",
  },
  "settingsTeam.organizationUsers.admin": {
    en: "Administrator",
    es: "Administrador",
  },
  "settingsTeam.organizationUsers.user": {
    en: "User",
    es: "Usuario",
  },
  "settingsCustomFields.customFields": {
    en: "Proposal's custom fields",
    es: "Campos personalizados para las propuestas",
  },
  "settingsCustomFields.form.key.label": {
    en: "Name",
    es: "Nombre",
  },
  "settingsCustomFields.form.key.placeholder": {
    en: "Alternate Address",
    es: "Dirección Alternativa",
  },
  "settingsCustomFields.form.value.label": {
    en: "Value",
    es: "Valor",
  },
  "settingsCustomFields.form.value.placeholder": {
    en: "1234 Pine Street",
    es: "Plaza Mayor 5, 4ºD",
  },
  "settingsCustomFields.form.submit": {
    en: "Save",
    es: "Guardar",
  },
  "settingsCustomFields.form.saving": {
    en: "Saving...",
    es: "Guardando",
  },
  "settingsCustomFields.form.customField.remove": {
    en: "Remove custom field",
    es: "Eliminar el campo personalizado",
  },
  "stripeCardElement.creditCard": {
    en: "Credit or debit card",
    es: "Tarjeta de crédito o débito",
  },
  "profilePage.title": {
    en: "User profile",
    es: "Perfil de usuario",
  },
  "profilePage.fromGoogle": {
    en: "(With Google)",
    es: "(A través de Google)",
  },
  "profilePage.updateProfileImage": {
    en: "Update profile image",
    es: "Actualizar foto de perfil",
  },
  "profilePage.deleteProfileImage": {
    en: "Delete profile image",
    es: "Eliminar foto de perfil",
  },
  "profilePage.profileData": {
    en: "Profile information",
    es: "Datos de perfil",
  },
  "profilePage.form.name.label": {
    en: "Name",
    es: "Nombre",
  },
  "profilePage.form.surname.label": {
    en: "Last name",
    es: "Apellidos",
  },
  "profilePage.form.name.submit": {
    en: "Update",
    es: "Actualizar",
  },
  "profilePage.form.name.updating": {
    en: "Updating....",
    es: "Actualizando...",
  },
  "profilePage.changeEmail": {
    en: "Change email",
    es: "Cambiar email",
  },
  "profilePage.form.email.label": {
    en: "Email",
    es: "Email",
  },
  "profilePage.form.email.submit": {
    en: "Change",
    es: "Cambiar",
  },
  "profilePage.form.email.updating": {
    en: "Changing...",
    es: "Cambiando...",
  },
  "profilePage.changePassword": {
    en: "Change password",
    es: "Cambiar contraseña",
  },
  "profilePage.form.oldPassword.label": {
    en: "Old password",
    es: "Contraseña vieja",
  },
  "profilePage.form.password.label": {
    en: "New password",
    es: "Nueva contraseña",
  },
  "profilePage.form.password.error.pattern": {
    en: "8 to 20 Characters, one number and one letter",
    es: "8 a 20 Caracteres, un número y una letra.<br/>",
  },
  "profilePage.form.repeatPassword.label": {
    en: "Confirm password",
    es: "Repite la contraseña",
  },
  "profilePage.form.repeatPassword.error.match": {
    en: "Passwords don't match",
    es: "La contraseña no coincide",
  },
  "profilePage.form.password.submit": {
    en: "Change",
    es: "Cambiar",
  },
  "profilePage.form.password.updating": {
    en: "Changing...",
    es: "Cambiando...",
  },
  "profilePage.removeIntegration": {
    en: "Remove integration",
    es: "Eliminar integración",
  },
  "profilePage.notifications": {
    en: "Notifications",
    es: "Suscripciones",
  },
  "profilePage.notifications.newsletter": {
    en: "I want to subscribe to <i>Quoters newsletter</i> to get the latest news and receive advices that help my business.",
    es: "Quiero suscribirme a la <i>newsletter</i> para conocer las últimas novedades y recibir consejos que ayuden a mi negocio.",
  },
  "profilePage.notifications.discount": {
    en: "I want you to send me discounts and exclusive personalized offers.",
    es: "Quiero que me enviéis descuentos y ofertas exclusivas personalizadas.",
  },
  "profilePage.smartVaultIntegration": {
    en: "SmartVault Integration",
    es: "Integración con SmartVault",
  },
  "quoteTemplateEditNameModal.title": {
    en: "Rename Template",
    es: "Renombrar Plantilla",
  },
  "quoteTemplateEditNameModal.close": {
    en: "Close",
    es: "Cerrar",
  },
  "quoteTemplateImportModal.title": {
    en: "Import template",
    es: "Importar nueva plantilla",
  },
  "quoteTemplateImportModal.form.label.templateCode": {
    en: "Template code",
    es: "Código de plantilla",
  },
  "quoteTemplateImportModal.form.submit": {
    en: "Import",
    es: "Importar",
  },
  "quoteTemplateShareModal.title": {
    en: "Share Template",
    es: "Compartir plantilla",
  },
  "quoteTemplateShareModal.code": {
    en: "Template code: ",
    es: "Código:",
  },
  "quoteTemplateShareModal.copied": {
    en: "Copied!",
    es: "¡Copiado!",
  },
  "quoteTemplateShareModal.toggleShare.label": {
    en: "Share this template",
    es: "Marcar como plantilla compartida",
  },
  "quoteTemplateShareModal.copyCode": {
    en: "Copy code",
    es: "Copiar código",
  },
  "templateSelectorPage.header.yourTemplates": {
    en: "Your templates",
    es: "Tus plantillas",
  },
  "templateSelectorPage.description.yourTemplates": {
    en: "These are your very own Quoters templates.",
    es: "Estas son las plantillas de presupuestos que has guardado en Quoters.",
  },
  "templateSelectorPage.action.importTemplates": {
    en: "Import templates",
    es: "Importar plantillas",
  },
  "templateSelectorPage.action.importTemplates.tooltip": {
    en: 'You can import templates specially crafted by another business. Click on "Import templates" and type the template code.',
    es: 'Puedes importar plantillas ya creadas en otra organización. Para ello, pulsa en "Importar plantillas" e introduce el código de la misma.',
  },
  "templateSelectorPage.newQuote": {
    en: "+ NEW PROPOSAL",
    es: "+ NUEVO PRESUPUESTO",
  },
  "templateSelectorPage.rename.placeholder": {
    en: "Rename",
    es: "Renombrar",
  },
  "templateSelectorPage.share.placeholder": {
    en: "Share",
    es: "Compartir",
  },
  "templateSelectorPage.delete.placeholder": {
    en: "Delete",
    es: "Eliminar",
  },
  "templateSelectorPage.importedTemplate": {
    en: "Imported template",
    es: "Plantilla importada",
  },
  "templateSelectorPage.header.defaultTemplates": {
    en: "Discover our winning templates",
    es: "Descubre nuestras plantillas ganadoras",
  },
  "templateSelectorPage.description.defaultTemplates": {
    en: "Creating a business proposal is complicated sometimes. That's why we crafted some templates specially for you. All of them are ready to use and filled in with your data automatically.",
    es: "Crear un presupuesto que venda más, en ocasiones, es complicado. Por eso, hemos creado estas plantillas adaptadas a cada sector. Están listas para usar y se rellenan con tus datos automáticamente.",
  },
  "costModalPricing.newCost": {
    en: "Create a new cost",
    es: "Crea un nuevo coste",
  },
  "costModalPricing.editCost": {
    en: "Edit cost",
    es: "Edita el coste",
  },
  "costModalPricing.form.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },
  "costModalPricing.form.unit.placeholder": {
    en: "Unit",
    es: "Und. de medida",
  },
  "costModalPricing.form.unit.error.required": {
    en: "Type cost unit (e.g: units, hours, metres, etc..)<br />",
    es: "Escribe la unidad de medida del coste (Ej: unidades, horas, metros, etc...)<br/>",
  },
  "costModalPricing.form.price.placeholder": {
    en: "Price",
    es: "Precio",
  },
  "costModalPricing.form.price.error.number": {
    en: "It has to be a number<br/>",
    es: "Debe ser un número<br/>",
  },
  "costModalPricing.form.price.error.min": {
    en: "It has to be positive<br/>",
    es: "Debe ser positivo<br/>",
  },
  "costModalPricing.form.price.error.max": {
    en: "The maximum valid amount is 9,999,999,999.99",
    es: "El valor máximo es 9,999,999,999.99",
  },
  "costModalPricing.form.price.error.maxLength": {
    en: "It is too long (max: 9.999.999.999,99)<br/>",
    es: "Demasiado largo (max: 9.999.999.999,99)<br/>",
  },
  "costModalPricing.form.comments.placeholder": {
    en: "Comments",
    es: "Notas relacionadas con el coste...",
  },
  "costModalPricing.form.saveOnLibrary": {
    en: "Save to cost library",
    es: "Guardar en biblioteca",
  },
  "costModalPricing.form.updateOnLibrary": {
    en: "Update on library",
    es: "Actualizar en biblioteca",
  },
  "costModalPricing.costsLibrary": {
    en: "Costs library",
    es: "Biblioteca de Costes",
  },
  "costModalPricing.searchCosts.placeholder": {
    en: "Search on costs",
    es: "Buscar entre tus costes",
  },
  "costModalPricing.searchCosts.results": {
    en: "Search results:",
    es: "Resultados de la búsqueda:",
  },
  "costModalPricing.searchCosts.noResults": {
    en: "Ouch! We couldn't find any cost with that description. <br> Try again!",
    es: "¡Ouch! No hemos encontrado ningún coste con esa descripción.<br>¡Prueba otra vez!",
  },
  "costModalPricing.searchCosts.noCosts": {
    en: 'There are no costs yet!<br>Would you like to learn some? <a href="https://help.quoters.io/knowledgebase/manage-your-business-costs" target="_blank">Read this article.</a>',
    es: '¡Aún no tienes costes, Quoter!<br>¿Quieres aprender a crear uno? <a href="https://help.quoters.io/es/crear-y-editar-un-presupuesto/crear-costes" target="_blank">Lee este artículo.</a>',
  },
  "costModalPricing.searchCosts.showMore": {
    en: "Show more",
    es: "Ver más",
  },
  "date.form.placeholder": {
    en: "Pick a date",
    es: "Selecciona una fecha",
  },
  "date.form.closeText": {
    en: "Close",
    es: "Cerrar",
  },
  "date.form.clearText": {
    en: "Clear",
    es: "Borrar",
  },
  "date.form.currentText": {
    en: "Today",
    es: "Hoy",
  },
  "date.form.error.format": {
    en: "Choose a valid date.",
    es: "Escribe una fecha válida. Ej: 01/01/2016",
  },
  "date.form.error.required": {
    en: "Pick a date",
    es: "Selecciona una fecha",
  },
  "fontSelector.placeholder": {
    en: "Select a font",
    es: "Selecciona una fuente",
  },
  "fontSizeSelector.error.min": {
    en: "Minimum value is 8",
    es: "El valor mínimo es 8",
  },
  "fontSizeSelector.error.max": {
    en: "Maximum value is 128",
    es: "El valor máximo es 128",
  },
  "fontSizeSelector.error.step": {
    en: "Value has to be integer",
    es: "El valor debe ser un número entero",
  },
  "fontStyleChange.title": {
    en: "Font",
    es: "Fuente",
  },
  "fontStyleChange.defaultStyles.placeholder": {
    en: "If this box is unchecked, custom styling will be used as defined",
    es: "Si esta casilla está desmarcada, se utilizarán los estilos que se establezcan en esta ventana",
  },
  "fontStyleChange.defaultStyles.title": {
    en: "Default styles",
    es: "Estilos por defecto",
  },
  "fontStyleChange.applyAllSections": {
    en: "Apply to all sections",
    es: "Aplicar a todas las secciones",
  },
  "fontStyleChange.header1": {
    en: "Header 1",
    es: "Título",
  },
  "fontStyleChange.header2": {
    en: "Header 2",
    es: "Subtítulo",
  },
  "fontStyleChange.paragraph": {
    en: "Paragraph",
    es: "Párrafo",
  },
  "imageSelector.chooseImage": {
    en: "Choose image",
    es: "Elegir imagen",
  },
  "imageSelector.changeImage": {
    en: "Change image",
    es: "Cambiar imagen",
  },
  "imageSelector.removeImage": {
    en: "Remove image",
    es: "Eliminar imagen",
  },
  "imageSelectorModal.gallery": {
    en: "Gallery",
    es: "Galería",
  },
  "imageSelectorModal.description": {
    en: "Add unique images for a unique proposal. Select one from Unsplash or upload your own photos or designs.",
    es: "Añade imágenes únicas para un presupuesto único. Elige en nuestro buscador o sube tus propias fotografías o diseños.",
  },
  "imageSelectorModal.uploadFile": {
    en: "Upload file",
    es: "Subir archivo",
  },
  "imageSelectorModal.popular": {
    en: "Most popular",
    es: "Popular",
  },
  "imageSelectorModal.recent": {
    en: "Most recent",
    es: "Recientes",
  },
  "imageSelectorModal.unsplash.placeholder": {
    en: "Image search at Unsplash",
    es: "Busca fotos en Unsplash",
  },
  "imageSelectorModal.unsplash.text": {
    en: "You can search by topics or colours",
    es: "Puedes buscar por temas o colores.",
  },
  "imageSelectorModal.unsplash.english.tooltip": {
    en: "Remember to search by using English words. E.g: dog",
    es: "Recuerda hacer tus búsquedas en inglés. Ejemplo: dog",
  },
  "imageSelectorModal.select": {
    en: "Select",
    es: "Seleccionar",
  },
  "imageSelectorModal.noMoreResults": {
    en: "There are no more results",
    es: "No hay más resultados",
  },
  "imageSelectorModal.unsplash.down": {
    en: "Unsplash is temporarily not available, try again later.",
    es: "Unsplash no está disponible temporalmente, inténtalo de nuevo más tarde.",
  },
  "imageSelectorModal.reload": {
    en: "Reload",
    es: "Actualizar",
  },
  "navbarOverQuote.version": {
    en: "Version __$1__",
    es: "Versión __$1__",
  },
  "navbarOverQuote.seeVersion": {
    en: "View v__$1__",
    es: "Ver v__$1__",
  },
  "navbarOverQuote.preview": {
    en: "Preview",
    es: "Previsualizar",
  },
  "navbarOverQuote.share": {
    en: "Share",
    es: "Compartir",
  },
  "navbarOverQuote.downloadPdf": {
    en: "Download PDF",
    es: "Descargar en PDF",
  },
  "navbarOverQuote.saveTemplate": {
    en: '<i class="zmdi zmdi-file"></i> Save template',
    es: '<i class="zmdi zmdi-file"></i> Guardar plantilla',
  },
  "navbarOverQuote.delete": {
    en: '<i class="zmdi zmdi-delete"></i> Delete',
    es: '<i class="zmdi zmdi-delete"></i> Eliminar',
  },
  "navbarOverQuote.lastSavedTime": {
    en: "Saved for the last time on __$1__",
    es: "Guardado por última vez el __$1__",
  },
  "placeholderModal.header": {
    en: "Placeholders",
    es: "Variables",
  },
  "placeholderModal.description": {
    en: "Placeholders are intented to include information in your proposal. E.g: If you want to add your contact's name, copy the corresponding placeholder <code>{{contact_first_name}}</code> and paste it into the document.",
    es: "Las variables sirven para incluir datos de manera rápida en tu presupuesto. Por ejemplo: si quieres añadir el nombre de tu contacto, copia la variable correspondiente <code>{{contacto_nombre}}</code> y pégala en el documento.",
  },
  "placeholderModal.description.optional": {
    en: "Optional: Optional placeholders will not be substituted if they do not have a related value.",
    es: "Opcional: Las variables opcionales no se sustuirán si no tienen un valor asociado.",
  },
  "placeholderModal.anyQuestions": {
    en: 'Any question? Read our <a target="_blank" href="https://help.quoters.io/knowledgebase/using-placeholders/">post</a> about how to use placeholders in Quoters.',
    es: '¿Tienes dudas? Lee nuestro <a target="_blank" href="https://quoters.io/es/nueva-funcionalidad-variables/">post</a> sobre cómo utilizar nuestras variables en Quoters.',
  },
  "placeholderModal.quote": {
    en: "Proposal",
    es: "Presupuesto",
  },
  "placeholderModal.quote.description": {
    en: "{{quote_description}}",
    es: "{{presupuesto_descripcion}}",
  },
  "placeholderModal.quote.code": {
    en: "{{quote_code}}",
    es: "{{presupuesto_codigo}}",
  },
  "placeholderModal.quote.date": {
    en: "{{quote_date}}",
    es: "{{presupuesto_fecha}}",
  },
  "placeholderModal.quote.expiration_date": {
    en: "{{quote_expiration_date}}",
    es: "{{presupuesto_fecha_validez}}",
  },
  "placeholderModal.taxYear.current": {
    en: "{{current_tax_year}}",
    es: "{{ano_fiscal_actual}}",
  },
  "placeholderModal.taxYear.previous": {
    en: "{{previous_tax_year}}",
    es: "{{ano_fiscal_previo}}",
  },
  "placeholderModal.taxYear.next": {
    en: "{{next_tax_year}}",
    es: "{{ano_fiscal_siguiente}}",
  },
  "placeholderModal.quote.version": {
    en: "{{quote_version}}",
    es: "{{presupuesto_version}}",
  },
  "placeholderModal.organization": {
    en: "Business",
    es: "Organización",
  },
  "placeholderModal.organization.name": {
    en: "{{business_name}}",
    es: "{{organizacion_nombre}}",
  },
  "placeholderModal.organization.address": {
    en: "{{business_address}}",
    es: "{{organizacion_direccion}}",
  },
  "placeholderModal.placeholder.optional": {
    en: "(optional)",
    es: "(opcional)",
  },
  "placeholderModal.organization.address_2": {
    en: "{{business_address_2}}",
    es: "{{organizacion_direccion_2}}",
  },
  "placeholderModal.organization.state": {
    en: "{{business_state}}",
    es: "{{organizacion_provincia}}",
  },
  "placeholderModal.organization.city": {
    en: "{{business_city}}",
    es: "{{organizacion_ciudad}}",
  },
  "placeholderModal.organization.country": {
    en: "{{business_country}}",
    es: "{{organizacion_pais}}",
  },
  "placeholderModal.organization.zip": {
    en: "{{business_zip}}",
    es: "{{organizacion_cp}}",
  },
  "placeholderModal.organization.web": {
    en: "{{business_web}}",
    es: "{{organizacion_web}}",
  },
  "placeholderModal.client": {
    en: "Client",
    es: "Cliente",
  },
  "placeholderModal.client.organization": {
    en: "{{client_organization}}",
    es: "{{cliente_organizacion}}",
  },
  "placeholderModal.contact": {
    en: "Contact",
    es: "Contacto",
  },
  "placeholderModal.contact.email": {
    en: "{{contact_email}}",
    es: "{{contacto_email}}",
  },
  "placeholderModal.contact.name": {
    en: "{{contact_first_name}}",
    es: "{{contacto_nombre}}",
  },
  "placeholderModal.contact.middleName": {
    en: "{{contact_middle_name}}",
    es: "{{contacto_segundo_nombre}}",
  },
  "placeholderModal.contact.lastName": {
    en: "{{contact_last_name}}",
    es: "{{contacto_apellidos}}",
  },
  "placeholderModal.contact.primaryPhone": {
    en: "{{contact_primary_phone}}",
    es: "{{contacto_tlf_principal}}",
  },
  "placeholderModal.contact.secondaryPhone": {
    en: "{{contact_secondary_phone}}",
    es: "{{contacto_tlf_secundario}}",
  },
  "placeholderModal.contact.appointment": {
    en: "{{contact_appointment}}",
    es: "{{contacto_cargo}}",
  },
  "placeholderModal.contact.company": {
    en: "{{contact_business_name}}",
    es: "{{contacto_empresa}}",
  },
  "placeholderModal.contact.nif": {
    en: "{{contact_id_number}}",
    es: "{{contacto_nif}}",
  },
  "placeholderModal.contact.address": {
    en: "{{contact_address}}",
    es: "{{contacto_direccion}}",
  },
  "placeholderModal.contact.address_2": {
    en: "{{contact_address_2}}",
    es: "{{contacto_direccion_2}}",
  },
  "placeholderModal.contact.city": {
    en: "{{contact_city}}",
    es: "{{contacto_ciudad}}",
  },
  "placeholderModal.contact.state": {
    en: "{{contact_state}}",
    es: "{{contacto_provincia}}",
  },
  "placeholderModal.contact.country": {
    en: "{{contact_country}}",
    es: "{{contacto_pais}}",
  },
  "placeholderModal.contact.zip": {
    en: "{{contact_zip}}",
    es: "{{contacto_cp}}",
  },
  "placeholderModal.copied": {
    en: "Copied!",
    es: "¡Copiado!",
  },
  "placeholderModal.noValue": {
    en: "No value",
    es: "No establecido",
  },
  "placeholderModal.customFields": {
    en: "Custom placeholder",
    es: "Campos personalizados",
  },
  "sectionGalleryModal.header": {
    en: "Sections from your library",
    es: "Secciones de tu biblioteca",
  },
  "sectionGalleryModal.body.noSections": {
    en: "You don't have any saved sections! <br /> Do it on section options.",
    es: "¡Aún no tienes secciones, Quoter!<br />Puedes guardarlas desde opciones de sección.",
  },
  "sectionGalleryModal.searchBar.placeholder": {
    en: "Search by name",
    es: "Buscar por nombre",
  },
  "sectionGalleryModal.sortBy": {
    en: "Order by:",
    es: "Ordenar por:",
  },
  "sectionGalleryModal.sortBy.name": {
    en: "name",
    es: "nombre",
  },
  "sectionGalleryModal.sortBy.date": {
    en: "date",
    es: "fecha",
  },
  "sectionGalleryModal.action.delete": {
    en: "Delete",
    es: "Eliminar",
  },
  "sectionGalleryModal.action.rename": {
    en: "Rename",
    es: "Renombrar",
  },

  "pricingTable.description": {
    en: "Description",
    es: "Descripción",
  },
  "pricingTable.quantity": {
    en: "Quantity",
    es: "Cantidad",
  },
  "pricingTable.price": {
    en: "Price",
    es: "Precio",
  },
  "pricingTable.margin": {
    en: "Margin (%)",
    es: "Margen (%)",
  },
  "pricingTable.discount": {
    en: "Disc (%)",
    es: "Dto (%)",
  },
  "pricingTable.optional": {
    en: "Optional",
    es: "Opcional",
  },
  "pricingTable.costsOnTariff.placeholder": {
    en: "This proposal line has related costs",
    es: "Esta línea de presupuesto tiene costes asociados",
  },
  "pricingTable.selectedByClient.default.placeholder": {
    en: "Selected by default",
    es: "Seleccionada por defecto",
  },
  "pricingTable.selectedByClient.notDefault.placeholder": {
    en: "No selected by default",
    es: "No seleccionada por defecto",
  },
  "pricingTable.addTariffToLibrary": {
    en: "Add this rate to the library",
    es: "Añadir esta tarifa a la biblioteca",
  },
  "pricingTable.updateTariffOnLibrary": {
    en: "Update rate on library",
    es: "Actualizar tarifa en biblioteca",
  },
  "pricingTable.moveUp": {
    en: "Move up",
    es: "Mover hacia arriba",
  },
  "pricingTable.moveDown": {
    en: "Move down",
    es: "Mover hacia abajo",
  },
  "pricingTable.delete": {
    en: "Delete",
    es: "Eliminar",
  },
  "pricingTable.cost.description": {
    en: "Cost Description",
    es: "Descripción Coste",
  },
  "pricingTable.cost.quantity": {
    en: "Quantity",
    es: "Cantidad",
  },
  "pricingTable.cost.price": {
    en: "Price",
    es: "Precio",
  },
  "pricingTable.cost.unitPrice": {
    en: "Unit price",
    es: "Coste/Unidad Tarifa",
  },
  "pricingTable.cost.total": {
    en: "Total",
    es: "Total Coste",
  },
  "pricingTable.cost.total.tooltip": {
    en: "This is the product of the total cost for the amount of the rate",
    es: "Esto es el producto del coste total por la cantidad de la tarifa",
  },
  "pricingTable.cost.add": {
    en: "Add new cost",
    es: "Añadir un nuevo coste",
  },
  "pricingTable.tariff.add": {
    en: "Add item",
    es: "Añadir tarifa",
  },
  "pricingTable.showTotalTaxes": {
    en: "Show Total and Taxes",
    es: "Mostrar Total e Impuestos",
  },
  "pricingTable.totalTaxes": {
    en: "Total and taxes",
    es: "Total e impuestos",
  },
  "pricingTable.totalCosts": {
    en: "TOTAL COST",
    es: "TOTAL DE COSTES",
  },
  "pricingTable.totalMargin": {
    en: "PROFIT MARGIN",
    es: "MARGEN DE BENEFICIO",
  },
  "pricingTable.subtotal": {
    en: "SUBTOTAL",
    es: "SUBTOTAL",
  },
  "pricingTable.addTax": {
    en: "Add tax",
    es: "Añadir impuesto",
  },
  "pricingTable.taxCustom": {
    en: "Custom",
    es: "Personalizado",
  },
  "pricingTable.total": {
    en: "TOTAL",
    es: "TOTAL",
  },
  "pricingTable.form.error.quantity.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.quantity.min": {
    en: "The number has to be positive",
    es: "El número debe ser positivo",
  },
  "pricingTable.form.error.quantity.max": {
    en: "Number is too high (max: 9.999.999.99)",
    es: "Este número es demasiado alto (max: 9.999.999.99)",
  },
  "pricingTable.form.error.quantity.maxLength": {
    en: "Number is too long (max: 9.999.999,99)",
    es: "Este número es demasiado largo (max: 9.999.999,99)",
  },
  "pricingTable.form.error.price.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.price.min": {
    en: "Number has to be positive or zero",
    es: "El número debe ser positivo o cero",
  },
  "pricingTable.form.error.price.max": {
    en: "Number is too high (max: 9.999.999.999,99)",
    es: "Este número es demasiado alto (max: 9.999.999.999,99)",
  },
  "pricingTable.form.error.margin.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.margin.max": {
    en: "Number is too high (max: 10.000)",
    es: "Este número es demasiado alto (max: 10.000)",
  },
  "pricingTable.form.error.discount.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.discount.max": {
    en: "Number is too high (max: 100)",
    es: "Este número es demasiado alto (max: 100)",
  },
  "pricingTable.form.error.costQuantity.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.costQuantity.min": {
    en: "Number has to be positive",
    es: "El número debe ser positivo",
  },
  "pricingTable.form.error.costQuantity.max": {
    en: "Number is too high (max: 9.999.999,99)",
    es: "Este número es demasiado alto (max: 9.999.999,99)",
  },
  "pricingTable.form.error.costQuantity.maxLength": {
    en: "Number is too high (max: 9.999.999,99)",
    es: "Este número es demasiado alto (max: 9.999.999,99)",
  },
  "pricingTable.form.error.taxPercentage.number": {
    en: "It has to be a number",
    es: "Debes escribir un número",
  },
  "pricingTable.form.error.taxPercentage.max": {
    en: "Number is too high (max: 100)",
    es: "Este número es demasiado alto (max: 100)",
  },
  "pricingTable.form.error.taxPercentage.min": {
    en: "Number is too low (min: -100)",
    es: "Este número es demasiado pequeño (min: -100)",
  },
  "pricingTableModal.header": {
    en: "Pricing Table",
    es: "Tabla de Precios",
  },
  "pricingTableModal.exchangesUpdated": {
    en: "Exchange rate were updated on __$1__",
    es: "Tipos de cambio actualizados por última vez el __$1__",
  },
  "pricingTableModal.updateExchanges": {
    en: "Update exchange rates!",
    es: "¡Actualizar tipos de cambio!",
  },
  "pricingTablePreview.tooltip": {
    en: "Click to edit",
    es: "Clic para editar",
  },
  "pricingTablePreview.edit": {
    en: "Click to edit pricing table",
    es: "Haz clic aquí para editar la tabla de precios",
  },
  "pricingTablePreview.unit": {
    en: "Unit",
    es: "Und",
  },
  "quoteActivity.header": {
    en: "Recent actitvity",
    es: "Actividad reciente",
  },
  "quoteActivity.create": {
    en: "Proposal <strong>created</strong> by __$1__",
    es: "__$1__ <strong>creó</strong> el presupuesto",
  },
  "quoteActivity.changeToApproved": {
    en: '__$1__ changed the proposal status to <strong class="text-success">accepted</strong>',
    es: '__$1__ cambió el estado del presupuesto a <strong class="text-success">aceptado</strong>',
  },
  "quoteActivity.changeToRejected": {
    en: '__$1__ changed the proposal status to <strong class="text-danger">rejected</strong>',
    es: '__$1__ cambió el estado del presupuesto a <strong class="text-danger">rechazado</strong>',
  },
  "quoteActivity.approve": {
    en: 'Proposal was <strong class="text-success">accepted</strong> by __$1__',
    es: '__$1__ ha <strong class="text-success">aceptado</strong> el presupuesto',
  },
  "quoteActivity.reject": {
    en: 'Proposal was <strong class="text-danger">rejected</strong> by __$1__',
    es: '__$1__ ha <strong class="text-danger">rechazado</strong> el presupuesto',
  },
  "quoteActivity.reject.comment": {
    en: " and commented: __$1__",
    es: " y escribió: __$1__",
  },
  "quoteActivity.getPublicView": {
    en: "Proposal <strong>public view</strong> was visited",
    es: "Se ha visitado la <strong>vista pública</strong> del presupuesto",
  },
  "quoteActivity.createNewVersion": {
    en: "A new proposal <strong>version was created</strong> by __$1__",
    es: "__$1__ <strong>creó una nueva version</strong> del presupuesto",
  },
  "quoteActivity.share": {
    en: "Proposal was <strong>shared</strong> by __$1__",
    es: "__$1__ <strong>compartió</strong> el presupuesto",
  },
  "quoteActivity.unshare": {
    en: "Proposal was <strong>unshared</strong> by __$1__",
    es: "__$1__ <strong>dejó de compartir</strong> el presupuesto",
  },
  "quoteActivity.archive": {
    en: "Proposal was <strong>archived</strong> by __$1__",
    es: "__$1__ <strong>archivó</strong> el presupuesto",
  },
  "quoteActivity.unarchive": {
    en: "Proposal was <strong>unarchived</strong> by __$1__",
    es: "__$1__ <strong>reactivó</strong> el presupuesto",
  },
  "quoteHeaderModal.header.new": {
    en: "Start a new proposal here",
    es: "Aquí comienza tu nuevo presupuesto",
  },
  "quoteHeaderModal.header.edit": {
    en: "Edit proposal",
    es: "Editar presupuesto",
  },
  "quoteHeaderModal.form.prospectiveClient.label": {
    en: "Prospective client",
    es: "Posible cliente",
  },
  "quoteHeaderModal.form.description.label": {
    en: "Proposal title*",
    es: "Título del presupuesto*",
  },
  "quoteHeaderModal.form.account.label": {
    en: "SmartVault Account*",
    es: "Cuenta de SmartVault*",
  },
  "quoteHeaderModal.form.prospectiveClientName.label": {
    en: "Client name*",
    es: "Nombre del cliente*",
  },
  "quoteHeaderModal.form.prospectiveClientName.placeholder": {
    en: "Acme",
    es: "Acme",
  },
  "quoteHeaderModal.form.mainContactName.label": {
    en: "Main contact first name*",
    es: "Nombre del contacto principal*",
  },
  "quoteHeaderModal.form.mainContactName.placeholder": {
    en: "Jane",
    es: "María",
  },
  "quoteHeaderModal.form.mainContactSurname.label": {
    en: "Main contact last name*",
    es: "Apellido del contacto principal*",
  },
  "quoteHeaderModal.form.mainContactSurname.placeholder": {
    en: "Doe",
    es: "García",
  },
  "quoteHeaderModal.form.mainContactEmail.label": {
    en: "Main contact email*",
    es: "E-mail del contacto principal*",
  },
  "quoteHeaderModal.form.mainContactEmail.placeholder": {
    en: "jane.doe@gmail.com",
    es: "maria.garcia@gmail.com",
  },
  "quoteHeaderModal.form.role.label": {
    en: "Role",
    es: "Rol",
  },
  "quoteHeaderModal.form.contactName.label": {
    en: "Contact first name",
    es: "Nombre del contacto",
  },
  "quoteHeaderModal.form.contactSurname.label": {
    en: "Contact last name",
    es: "Apellido del contacto",
  },
  "quoteHeaderModal.form.contactName.placeholder": {
    en: "John",
    es: "Juan",
  },
  "quoteHeaderModal.form.contactEmail.label": {
    en: "Contact email",
    es: "Email del contacto",
  },
  "quoteHeaderModal.form.contactEmail.placeholder": {
    en: "john.doe@gmail.com",
    es: "juan.fernandez@gmail.com",
  },
  "quoteHeaderModal.form.contactSurname.placeholder": {
    en: "Doe",
    es: "Fernández",
  },
  "quoteHeaderModal.form.additionalContacts": {
    en: "Additional contacts",
    es: "Contactos adicionales",
  },
  "quoteHeaderModal.form.addContact": {
    en: "Add contact",
    es: "Añadir contacto",
  },
  "quoteHeaderModal.form.client.label": {
    en: "SmartVault Client*",
    es: "Cliente de SmartVault*",
  },
  "quoteHeaderModal.form.description.placeholder": {
    en: "Web site design",
    es: "Diseño de página web",
  },
  "quoteHeaderModal.form.email.patternError": {
    en: "Invalid email format",
    es: "Formato de email no válido",
  },
  "quoteHeaderModal.form.contacts.label": {
    en: "Contacts*",
    es: "Contactos*",
  },
  "quoteHeaderModal.form.contacts.error": {
    en: "The selected client has not activated their SmartVault login. Please invite the client and wait until they have activated their login before attempting to send a proposal.",
    es: "El cliente seleccionado no ha activado su inicio de sesión en SmartVault. Invite al cliente y espere hasta que haya activado su inicio de sesión antes de intentar enviar una propuesta.",
  },
  "quoteHeaderModal.form.contactRole.label": {
    en: "Role",
    es: "Rol",
  },
  "quoteHeaderModal.form.mainContact": {
    en: "Main contact",
    es: "Contacto principal",
  },
  "quoteHeaderModal.form.removeContact": {
    en: "Remove",
    es: "Eliminar",
  },
  "quoteHeaderModal.form.account.select.any": {
    en: "Choose an account",
    es: "Escoge una cuenta",
  },
  "quoteHeaderModal.form.client.select.any": {
    en: "Search a client",
    es: "Busca a un cliente",
  },
  "quoteHeaderModal.form.client.select.searchLabel": {
    en: "Start typing to search a client...",
    es: "Escribe para buscar a un cliente...",
  },
  "quoteHeaderModal.form.client.select.noClients": {
    en: "There's no search match...",
    es: "No hay coincidencias con la búsqueda...",
  },
  "quoteHeaderModal.form.client.error.deniedAccess": {
    en: "Access Denied. You don't have rights to access this client data.",
    es: "Acceso denegado. No tienes permisos para ver los datos de este cliente.",
  },
  "quoteHeaderModal.form.contact.select.empty": {
    en: "There are no contacts yet",
    es: "Aún no tienes ningún contacto",
  },
  "quoteHeaderModal.form.contact.select.any": {
    en: "Choose a contact",
    es: "Selecciona un contacto",
  },
  "quoteHeaderModal.form.role.select.any": {
    en: "Choose a role",
    es: "Selecciona un rol",
  },
  "quoteHeaderModal.form.role.option.viewer": {
    en: "Viewer",
    es: "Revisor",
  },
  "quoteHeaderModal.form.role.option.acceptor": {
    en: "Acceptor",
    es: "Aceptador",
  },
  "quoteHeaderModal.form.contact.create": {
    en: "NEW CONTACT",
    es: "NUEVO CONTACTO",
  },
  "quoteHeaderModal.form.additionalData": {
    en: "Additional settings",
    es: "Configuraciones adicionales",
  },
  "quoteHeaderModal.form.currency.label": {
    en: "Currency",
    es: "Divisa",
  },
  "quoteHeaderModal.form.quoteNumber.label": {
    en: "Proposal number",
    es: "Número de presupuesto",
  },
  "quoteHeaderModal.form.quotePrefix.label": {
    en: "Proposal prefix",
    es: "Prefijo de presupuesto",
  },
  "quoteHeaderModal.form.quoteNumber.prefix.choose": {
    en: "Choose other",
    es: "Elegir otro",
  },
  "quoteHeaderModal.form.quoteNumber.prefix.noPrefix": {
    en: "(No prefix)",
    es: "(Sin prefijo)",
  },
  "quoteHeaderModal.form.quoteNumber.number.error.maxLength": {
    en: "Between 1 and 9999",
    es: "Entre 1 y 9999",
  },
  "quoteHeaderModal.form.quoteNumber.number.error.max": {
    en: "Between 1 and 9999",
    es: "Entre 1 y 9999",
  },
  "quoteHeaderModal.form.quoteNumber.number.error.min": {
    en: "Between 1 and 9999",
    es: "Entre 1 y 9999",
  },
  "quoteHeaderModal.form.quoteNumber.number.error.valueGreaterOrEqualThan": {
    en: "It has to be equal or higher than __$1__<br/>",
    es: "Debe ser mayor o igual que __$1__<br/>",
  },
  "quoteHeaderModal.form.language.label": {
    en: "Language",
    es: "Idioma",
  },
  "quoteHeaderModal.form.date.label": {
    en: "Date",
    es: "Fecha",
  },
  "quoteHeaderModal.form.date.error.date": {
    en: "It's not a valid date",
    es: "No es una fecha válida",
  },
  "quoteHeaderModal.form.expirationDate.label": {
    en: "Expiration date",
    es: "Válido hasta",
  },
  "quoteHeaderModal.form.expirationDate.error.date": {
    en: "It's not a valid date",
    es: "No es una fecha válida",
  },
  "quoteHeaderModal.form.emailToCustomerOnAccept": {
    en: "Send email to customer when accepts",
    es: "Enviar email al cliente cuando acepte",
  },
  "quoteHeaderModal.form.pdfDownloadable": {
    en: "PDF downloadable by client",
    es: "PDF descargable por el cliente",
  },
  "quoteHeaderModal.form.approveFromPublicView": {
    en: "Allow to accept proposal online",
    es: "Permitir aceptar presupuesto online",
  },
  "quoteHeaderModal.form.approveFromPublicView.tooltip": {
    en: 'When it\'s selected the "Accept" button will be visible on public view.',
    es: "Al seleccionarlo, aparecerá en la vista pública el botón de “Aceptar” presupuesto.",
  },
  "quoteHeaderModal.form.signature.tooltip": {
    en: "To use signature feature, go to Settings --> Proposals and configure it for your business there.",
    es: "Para poder usar esta opción es necesario que el dueño de la organización establezca una firma en Ajustes -> Presupuestos.",
  },
  "quoteHeaderModal.form.signature": {
    en: "Signature required to accept the proposal",
    es: "Requerir firma para aceptar el presupuesto",
  },
  "quoteHeaderModal.form.signature.info": {
    en: "You can require your client to digitally sign you proposal to accept it.",
    es: "Puedes pedir a tu cliente que utilice nuestra firma digital para aceptar el presupuesto.",
  },
  "quoteHeaderModal.tooltip.signed": {
    en: "__$1__ accepted on __$2__.",
    es: "__$1__ aceptó el __$2__.",
  },
  "quoteHeaderModal.tooltip.removeContact": {
    en: "Remove contact.",
    es: "Eliminar contacto.",
  },
  "quoteHeaderModal.tooltip.noEmail": {
    en: "Can't be added to the proposal without an email.",
    es: "No se puede añadir a una propuesta hasta que tenga email.",
  },
  "quoteHeaderModal.form.error.missingContact": {
    en: "This contact not longer exists in this Client",
    es: "Este contacto ya no existe en este Cliente",
  },
  "quoteHeaderModal.tooltip.emailNotActived": {
    en: "Can't be added to the proposal until contact accepts its SmartVault invitation.",
    es: "No se puede añadir a una propuesta hasta que el contacto haya aceptado su invitación a SmartVault.",
  },
  "quoteHeaderModal.form.submit": {
    en: "Let's go!",
    es: "¡ADELANTE!",
  },
  "quoteHeaderModal.close": {
    en: "Close",
    es: "Cancelar",
  },

  "quoteNewSection.header.title": {
    en: "Create a new section",
    es: "Crea una nueva sección",
  },
  "quoteNewSection.header.description": {
    en: "Add a new section. Include your rates or reuse the sections that you have saved in other proposals.",
    es: "Añade una nueva sección. Incluye tus tarifas o reutiliza las secciones que hayas guardado en otros presupuestos.",
  },
  "quoteNewSection.header.cancel": {
    en: "Cancel",
    es: "Cancelar",
  },
  "quoteNewSection.type.text": {
    en: "Text, images or videos.",
    es: "Texto, fotos o vídeos",
  },
  "quoteNewSection.type.pricingTable": {
    en: "Pricing table",
    es: "Tabla de precios",
  },
  "quoteNewSection.type.gallery": {
    en: "Saved sections",
    es: "Secciones guardadas",
  },

  "quoteSection.save.label": {
    en: "Save section",
    es: "Guardar sección",
  },

  "quoteSection.background.label": {
    en: "Background",
    es: "Fondo",
  },
  "quoteSection.font.label": {
    en: "Font",
    es: "Fuente",
  },
  "quoteSection.delete.label": {
    en: "Delete",
    es: "Eliminar",
  },
  "quoteSection.moveDown.placeholder": {
    en: "Move down",
    es: "Mover abajo",
  },
  "quoteSection.moveUp": {
    en: "Move up",
    es: "Mover arriba",
  },
  "quoteSection.fullScreen": {
    en: "Expand",
    es: "Expandir",
  },
  "quoteSection.autoSize": {
    en: "Auto size",
    es: "Tamaño automático",
  },
  "quoteSection.cancel": {
    en: "Cancel",
    es: "Cancelar",
  },
  "quoteSection.newSection": {
    en: "New section",
    es: "Nueva sección",
  },

  "quoteSectionNameForm.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },

  "quoteSectionNameModal.header": {
    en: "Section name",
    es: "Nombre de sección",
  },

  "quoteShareModal.shareThrough": {
    en: "Share through:",
    es: "Compartir mediante:",
  },
  "quoteShareModal.shareThrough.or": {
    en: "or",
    es: "o",
  },
  "quoteShareModal.header.title": {
    en: "Share",
    es: "Compartir",
  },
  "quoteShareModal.publicUrl": {
    en: "Public URL:",
    es: "URL pública:",
  },
  "quoteShareModal.copied": {
    en: "Copied!",
    es: "¡Copiado!",
  },
  "quoteShareModal.toggleShare.label": {
    en: "Make this proposal public to your client",
    es: "Marcar como presupuesto visible para tu cliente",
  },
  "quoteShareModal.toggleShare.info": {
    en: "You can generate the proposal privately (only accessible by your business users) or make it public to your client.",
    es: "Puedes generar el presupuesto en privado (sólo accesible a tu organización) o bien hacerlo público para tu cliente.",
  },
  "quoteShareModal.copyLink": {
    en: "Copy link",
    es: "Copiar enlace",
  },
  "quoteShareModal.email.subject": {
    en: "Proposal from __$1__",
    es: "Presupuesto de __$1__",
  },
  "quoteShareModal.email.body": {
    en: "Hi __$1__,%0D%0A%0D%0AI am sending you the proposal we were working on. Visit it via this link:%0D%0A%0D%0A__$2__%0D%0A%0D%0AGreetings",
    es: "Hola __$1__,%0D%0A%0D%0ATal y como nos has solicitado, a continuación te envío el presupuesto. Lo puedes ver a través de este enlace:%0D%0A%0D%0A__$2__%0D%0A%0D%0ASaludos",
  },

  "quoteTemplateCreateOverwriteModal.header": {
    en: "New template",
    es: "Nueva plantilla",
  },
  "quoteTemplateCreateOverwriteModal.update": {
    en: "Update template",
    es: "Actualizar Plantilla",
  },

  "quoteTemplateNameForm.name.placeholder": {
    en: "Name",
    es: "Nombre",
  },

  "sectionBackgroundSelector.header": {
    en: "Background",
    es: "Fondo",
  },
  "sectionBackgroundSelector.color": {
    en: "Colour",
    es: "Color",
  },
  "sectionBackgroundSelector.image": {
    en: "Image",
    es: "Imagen",
  },
  "sectionBackgroundSelector.video": {
    en: "Video",
    es: "Vídeo",
  },
  "sectionBackgroundSelector.color.main": {
    en: "Main",
    es: "Principal",
  },
  "sectionBackgroundSelector.color.secondary": {
    en: "Secondary",
    es: "Secundario",
  },
  "sectionBackgroundSelector.color.other": {
    en: "Overlay",
    es: "Overlay",
  },
  "sectionBackgroundSelector.color.none": {
    en: "None",
    es: "Ninguno",
  },
  "sectionBackgroundSelector.changeColors": {
    en: 'You can change this colours on <a href="__$1__">business settings.</a>',
    es: 'Puedes cambiar estos colores en la <a href="__$1__">configuración de la organización.</a>',
  },
  "sectionBackgroundSelector.video.soundEnabled": {
    en: "Sound on",
    es: "Sonido activado",
  },
  "sectionBackgroundSelector.video.set": {
    en: "Set",
    es: "Establecer",
  },
  "sectionBackgroundSelector.video.delete": {
    en: "Delete",
    es: "Eliminar",
  },
  "createProposal.error": {
    en: "SmartVault Account or client doesn't exist.",
    es: "La cuenta o el cliente de SmartVault no existe.",
  },
};
